import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { ModalBody, ModalFooter, ModalHeader, OverlayTrigger, Popover, Tooltip } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import ReactStars from 'react-rating-stars-component';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import useConfiguration from '../../hooks/useConfiguration';
import useSessionStorage from '../../hooks/useSessionStorage';
import Modal from "../common/Modal/modal";
import { ModalBox } from "react-bootstrap";
import {
  editPost,
  resetJobOpportunityInfo,
  setAcceptableDistance,
  setJobId,
} from '../JobOpportunity/action';
import Footer from '../common/Footer';
import GridTable from '../common/GridTable';
import Header from '../common/Header';
import Loader from '../common/Loader';
import Sidebar from '../common/Sidebar';
import Spinner from '../common/Spinner/spinner';
import DropDown from '../common/TextField/dropDown';
import * as Toasts from '../common/Toastify';
import {
  AssignJobToCandidate,
  AssignJobToMultipleCandidate,
  clearData,
  fetchDollarDetails,
  getCallHistory,
  getMappedDepartmentsToCandi,
  getMatchingCandidateDetail,
  getOvertimeDetails,
  getShiftRelaseOrder,
  getShiftRelaseOrderWaitTime,
  getTeamListDetails,
  getTeamsByLocationDepartment,
  loadMasterData,
  mapDepartmentsToCandidate,
  resetParamVal,
  saveFavorite,
  sendAllEmailbtn,
  sendAllSmsbtn,
  sendPostJob,
  sendPostMultipleJobs,
  updateParams,
  updateStatus,
} from './action';
import { formatData, formatFirstTime } from './formatDragandDrop';
import './matchingcandidate.css';
import { matchingCandidateSelector } from './selector';
import Shiftorder from './shiftorder';
import { toast } from 'react-toastify';
import { getEmailDetails, getSMSDetails, sendEmail, sendSMS } from '../MatchingCandidate/action';
import SMSModal from '../common/Modal/SMSModal';
import EmailModal from '../common/Modal/EmailModal';
import CallModal from '../common/Modal/CallModal';
import moment from 'moment';
import OvertimeRadio from './OvertimeRadio';
import ToolTip from '../common/ToolTip/ToolTip';
import { useRef } from 'react';
import { useOutsideClick } from '../../hooks/useOutsideClick';
import DepsUnits from './depsUnits';
import { fetchDepsUnits } from '../Login/action';
import { setSortOrderType, setValue } from './slice';
import { shiftTypeObj } from '../../helpers/data';
import { getHoursandMinutes } from '../../helpers/service';
import ErrorMsgModal from '../common/Modal/ErrorMsgModal';
import Mentor from '../assets/svg/Mentor';
// eslint-disable-next-line import/no-anonymous-default-export
const initialSinglOvertime = {
  status: false,
  response: {},
}
const initialMultiOvertime = {
  status: false,
  response: [],
  params: {}
}
const initialPostOvertime = {
  status: false,
  response: [],
  params: {},
  type: ""
}
// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const {
    masterData,
    params,
    data,
    locationId,
    jobInfo,
    shiftReleaseOderList,
    shiftReleaseOderWaitTimeList,
    savedJobShiftReleaseOrderIds,
    jobPostedData,
    dropDownJobId,
    filterControls,
    loadingFlag,
    totalCount,
    isDataNotFound
  } = useSelector(matchingCandidateSelector);
  const sortOrderType = useSelector(store => store.matchingCandidateInfo?.sortOrderType)
  const location = useLocation();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem('login');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = useState(params);
  const [searchErrors, setSearchErrors] = useState({});
  const [childarg, setChildarg] = useState({});
  const [tableData, setTableData] = useState(JSON.parse(JSON.stringify(data)));
  const [skipPageReset, setSkipPageReset] = useState(false);
  const [rowData, setRowData] = useState({});
  const [count, setCount] = useState(0);
  // SMS state 
  const [smsModalInd, setSmsModalInd] = useState(false);
  const [smsModalData, setSmsModalData] = useState({});
  const [smsModalGetData, setSmsModalGetData] = useState({ sms: "" });
  const [smsModalList, setSmsModalList] = useState([]);
  const [groupSMSSaveFlag, setGroupSMSSaveFlag] = useState(false);
  const [groupSMSData, setGroupSMSData] = useState(null);
  // Email state
  const [emailModalInd, setEmailModalInd] = useState(false);
  const [emailModalData, setEmailModalData] = useState([]);
  const [emailModalGetData, setEmailModalGetData] = useState({ subject: "" });
  const [emailModalList, setEmailModalList] = useState([]);
  const [groupEmailSaveFlag, setGroupEmailSaveFlag] = useState(false);
  const [groupEmailData, setGroupEmailData] = useState(null);
  // Call state
  const [callModalInd, setCallModalInd] = useState(false);
  const [callModalData, setCallModalData] = useState([]);
  const [callModalGetData, setCallModalGetData] = useState({ subject: "" });
  const [callModalList, setCallModalList] = useState([]);
  const [callParams, setCallParams] = useState("");
  const [showErrorModal,setShowErrorModal] = useState(false);
  const hiddenColumns = [
    'hoursWorked',
    'shiftsCompleted',
    'phone',
    'email',
    'city',
    'state',
    'zipcode',
  ];
  const {
    matchingJobid,
    acceptableTravelDistance,
    jobsClaimId,
    multishiftFlag,
    jobUniqueId,
    NoOfShiftsneeded,
    previousPath,
    postion,
    hideEditJobShiftType
  } = location.state || '';
  // console.log({hideEditJobShiftType});
  // console.log({NoOfShiftsneeded});
  const createJobPage = location.state.createJobPage
    ? location.state.createJobPage
    : false;
  const [showModal, setShowModal] = useState(false);
  const [showShiftRelase, setShowShiftRelase] = useState(false);
  const [shiftOrderSelectedData, setShiftOrderSelectedData] = useState({
    form: {
      time: jobPostedData?.releaseTimeIntervalInMinutes
        ? jobPostedData?.releaseTimeIntervalInMinutes
        : '',
      authorizedUser: jobPostedData?.releaseToAllAuthorized
        ? jobPostedData?.releaseToAllAuthorized
        : '',
    },
    data: '',
  });

  const [postjobDisable, setPostjobDisable] = useState(true);
  const [shiftOderValidation, setShiftOderValidation] = useState({});
  const [showRepostModal, setRepostModal] = useState(false);
  const [postjobData, setPostjobData] = useState({});
  const [selectCandidate, setSelectCandidate] = useState(false);
  const [statusrequest, setStatusrequest] = useState({});
  const [showStatusWaring, setShowStatusWaring] = useState(false);
  const [noOfShiftNeeded, setNoOfShiftNeeded] = useState("");
  const [errorModalBox, seterrorModalBox] = useState(false);
  const [overtimeValidModal, setOvertimeValidModal] = useState(initialSinglOvertime);
  const [overtimeMultiValidModal, setOvertimeMultiValidModal] = useState(initialMultiOvertime);
  const [multiAssignResponseModal, setMultiAssignResponseModal] = useState({ status: false, response: [] })
  const [postJobResponseModal, setPostJobResponseModal] = useState(initialPostOvertime)


  var dropdownJobtypeId;

  const [filterJobList, setFilterJobList] = useState({});
  const [hideSecurityJobColumns, sethideSecurityJobColumns] = useState([]);
  const [dontShowColumnsList, setdontShowColumnsList] = useState([]);
  const [schedulingModal, setSchedulingModal] = useState(false);
  const [candidateName, setCandidateName] = useState('');
  const [showDepartmentModal, setShowDepartmentModal] = useState({ status: false, result: {} });
  const [teamNameList, setTeamNameList] = useState([]);
  const depsUnitsRef = useRef()
  console.log(location, '------------>');
  useEffect(() => {
    document.title = 'Matching Candidate';
  }, []);

  useEffect(() => {
    setSkipPageReset(false);
  }, [tableData]);

  useEffect(() => {
    let filterVal = [];
    let hideSecurityJob = '';
    if (dropDownJobId) {
      filterVal = login.jobTypeFlags.jobTypeList.filter(
        (item) => item.jobTypeId === dropDownJobId
      )[0];
      if (filterVal) {
        setFilterJobList(filterVal);
      }
      dropdownJobtypeId = dropDownJobId;
    } else {
      filterVal = login.jobTypeFlags.jobTypeList[0];
      if (filterVal) {
        setFilterJobList(filterVal);
      }

      dropdownJobtypeId = dropDownJobId;
    }
  }, [dropDownJobId]);

  useEffect(() => {
    //let hideSecurityJob = "";
    //if(filterJobList?)
    let hiddenColumnsList = [];
    hiddenColumnsList = [
      'shiftsCompleted',
      // 'phone',
      // 'email',
      'city',
      'state',
      'zipcode',
    ];
    // if (filterJobList?.showCertifications) {
    //     hideSecurityJob = ['hoursWorked', 'shiftsCompleted', 'phone', 'email', 'city', 'state', 'zipcode','PreferredShiftTimDay','CertificatesPermitsLicensesTrainingSection1','CertificatesPermitsLicensesTrainingSection2'];
    //     //sethideSecurityJobColumns(hideSecurityJob);
    // }
    // else {
    //     hideSecurityJob = ['hoursWorked', 'shiftsCompleted', 'phone', 'email', 'city', 'state', 'zipcode', 'certificationsName', 'emrehrSystemName', 'specialtyName'];
    //     //sethideSecurityJobColumns(hideSecurityJob);
    // }
    const joblist = login?.jobTypeFlags?.jobTypeList
    if (filterJobList?.jobTypeId) {
      const newValue = [];
      //console.log('FilterJoblist:', filterJobList);
      if (!filterJobList?.showCertifications) {
        newValue.push('Certifications');
        hiddenColumnsList.push('certificationsName');
      }

      if (!filterJobList?.showEmr) {
        newValue.push('EMR/EHR');
        hiddenColumnsList.push('emrehrSystemName');
      }

      if (!filterJobList?.showSpecialties) {
        newValue.push('Specialties');
        hiddenColumnsList.push('specialtyName');
      }

      if (!login?.accountFlags?.isShowQATab) {
        // newValue.push('Preferred Shift Time of The Day');
        newValue.push('Certificates/Permits/Licenses/Training Section 1');
        newValue.push('Certificates/Permits/Licenses/Training Section 2');
        newValue.push('Experience and Skills');

        // hiddenColumnsList.push('preferredShiftTimeOfTheDayList');
        hiddenColumnsList.push('CertificatesPermitsLicensesTrainingSection1');
        hiddenColumnsList.push('CertificatesPermitsLicensesTrainingSection2');
        hiddenColumnsList.push('ExperienceandSkills');
      }

      if (login?.accountFlags?.isShowQATab) {
        if (joblist?.some(item => item.jobTypeId === 5) && !joblist?.some(item => item.jobTypeId === 2)) {
          newValue.push("Certificates/Permits/Licenses/Training Section 1");
          newValue.push("Certificates/Permits/Licenses/Training Section 2");
          hiddenColumnsList.push("CertificatesPermitsLicensesTrainingSection1");
          hiddenColumnsList.push("CertificatesPermitsLicensesTrainingSection2");
        }
        if (joblist?.some(item => item.jobTypeId === 2) && !joblist?.some(item => item.jobTypeId === 5)) {
          newValue.push("Experience and Skills");
          hiddenColumnsList.push("ExperienceandSkills");
        }
      }

      sethideSecurityJobColumns(hiddenColumnsList);
      setdontShowColumnsList(newValue);
    }
  }, [config]);

  useEffect(() => {
    if (jobPostedData) {
      setShiftOrderSelectedData({
        ...shiftOrderSelectedData,
        form: {
          time: jobPostedData?.releaseTimeIntervalInMinutes
            ? jobPostedData?.releaseTimeIntervalInMinutes
            : '',
          authorizedUser: jobPostedData?.releaseToAllAuthorized
            ? jobPostedData?.releaseToAllAuthorized
            : '',
        },
      });
    }
  }, [jobPostedData]);

  useEffect(() => {
    const formatdata = formatFirstTime(
      shiftReleaseOderList,
      savedJobShiftReleaseOrderIds
    );
    setShiftOrderSelectedData({
      ...shiftOrderSelectedData,
      data: formatdata,
    });
  }, [shiftReleaseOderList, savedJobShiftReleaseOrderIds]);
//   useEffect(() => {
//     const handler = (e) => {
//       if (previousPath && previousPath === '/jobopportunity') {
//         e.preventDefault();
//         dispatch(setJobId(undefined))
//         navigate(previousPath, {
//           state: {
//             fromMatchingCandidate: true,
//             postion: postion
//           }
//         })
//       } else {
//         e.preventDefault();
//         navigate(previousPath)
//       }
//     }
//     window.addEventListener("popstate", e => handler(e));
//     return () => {
//         window.removeEventListener("popstate", e => handler(e));
//     }
// }, [])
  useEffect(() => {
    const newData = JSON.parse(JSON.stringify(data));
    setTableData(newData);
  }, [data]);

  const [teamAssignEnableBtn, setTeamAssignEnableBtn] = useState(false);


  useEffect(() => {
    if (config.baseUrl) {
      if (!login) {
        navigate('/');
      } else {


        // if (previousPath && previousPath === '/jobopportunity') {
        //   console.log("insiiiiiiiiideeeeeeeeeeeeeeeeeee",previousPath);
        //   window.onpopstate = function (e) {
        //     e.preventDefault();
        //     dispatch(setJobId(undefined))
        //     navigate(previousPath, {
        //       state: {
        //         fromMatchingCandidate: true,
        //         postion: postion
        //       }
        //     })
        //   };
        // } else {
        //   window.onpopstate = function (e) {
        //     e.preventDefault();
        //     navigate(previousPath)
        //   };
        // }
        const newparams = {
          ...params,
          jobShiftUniqueId: matchingJobid,
          distance: acceptableTravelDistance,
          jobsClaimId: jobsClaimId ? jobsClaimId : 0,
        };

        dispatch(updateParams(newparams))
        dispatch(loadMasterData(`${config.baseUrl}`)).then(() => {
          dispatch(
            getMatchingCandidateDetail({
              url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
              params: newparams,
            })
          ).then(response => {
            const params = {
              locationId: response?.locationId,
              candidateDepartmentId: response?.jobInfo?.candidateDepartmentId,
              jobCategoryId: response?.jobInfo?.jobShiftLevelId
            }
            response?.locationId && dispatch(getTeamsByLocationDepartment({ baseUrl: config.baseUrl, params })).then(response => {
              setTeamNameList(response)
            })
          })

          if (!shiftReleaseOderList?.length) {
            dispatch(
              getShiftRelaseOrder({
                url: config.baseUrl,
              })
            );
          }

          if (!shiftReleaseOderWaitTimeList?.length) {
            dispatch(
              getShiftRelaseOrderWaitTime({
                url: config.baseUrl,
              })
            );
          }

        });

      }
    }
    sessionStorage.removeItem('selectedRows');
  }, [config]);

  // useEffect(() => {
  //   if(config.baseUrl){
  //     const newparams = {
  //       ...params,
  //       jobShiftUniqueId: matchingJobid,
  //       distance: acceptableTravelDistance,
  //       jobsClaimId: jobsClaimId ? jobsClaimId : 0,
  //     };
  //     const teamAssignParams = {
  //       ...params,
  //       matchingCriteria:null,
  //       distance: '0',
  //       jobShiftUniqueId: matchingJobid,
  //       jobsClaimId: jobsClaimId ? jobsClaimId : 0,
  //     }
  //     params.candidateTeamId === '0' ? dispatch(updateParams(newparams)) : dispatch(updateParams(teamAssignParams))
  //     dispatch(
  //       getMatchingCandidateDetail({
  //         url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
  //         params: params.candidateTeamId === '0' ? newparams : teamAssignParams,
  //       })
  //     );
  //   }
  // },[params.candidateTeamId])


  // get Teams List data
  // useEffect(() => {
  //   if (config.baseUrl && locationId) {
  //     dispatch(getTeamListDetails(`${config.baseUrl}/TeamScheduling/get-all-team-names?locationid=${locationId}`))
  //       .then((res) => setTeamNameList(res))
  //   }
  // }, [config.baseUrl, locationId])


  useEffect(() => {
    const newparams = {
      ...form,
    };
    dispatch(updateParams(newparams));
  }, [form]);

  useEffect(() => {
    return () => {
      dispatch(updateParams({
        "page": 1,
        "pageSize": 25,
        "sortOrder": "",
        "sortColumn": "",
        "distance": "50",
        "matchingCriteria": null,
        "searchStatus": [{ id: 98, name: "All" }],
        "SearchText": "",
        "jobShiftUniqueId": "",
        "IsBestMatch": false,
        "jobsClaimId": '',
        "candidateTeamId": '0'
      }));
      sessionStorage.removeItem('selectedRows');
    };
  }, [dispatch]);


  const clearFilter = () => {
    setSearchErrors({});
    setForm({
      page: 1,
      pageSize: 25,
      sortOrder: '',
      sortColumn: '',
      distance: '50',
      searchStatus: [{ id: 98, name: 'All' }],
      SearchText: '',
      matchingCriteria: null,
      jobShiftUniqueId: matchingJobid,
      IsBestMatch: false,
      jobsClaimId: jobsClaimId ? jobsClaimId : 0,
      candidateTeamId: '0'
    });
    dispatch(resetParamVal()).then(() => {
      setTimeout(() => {
        const newparams = {
          page: 1,
          pageSize: 25,
          sortOrder: '',
          sortColumn: '',
          distance: '50',
          searchStatus: [{ id: 98, name: 'All' }],
          SearchText: '',
          matchingCriteria: null,
          jobShiftUniqueId: matchingJobid,
          IsBestMatch: false,
          jobsClaimId: jobsClaimId ? jobsClaimId : 0,
          candidateTeamId: '0'
        };
        dispatch(
          getMatchingCandidateDetail({
            url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
            params: newparams,
          })
        );
      }, 800);
    });
  };

  const filterTable = () => {
    const newparams = {
      ...params,
      jobShiftUniqueId: matchingJobid,
      page: 1,
      pageSize: 25,
      IsBestMatch: false,
      jobsClaimId: jobsClaimId ? jobsClaimId : 0,
      "sortOrder": "",
      "sortColumn": "",
    };
    setForm({
      ...newparams,
    })
    dispatch(
      getMatchingCandidateDetail({
        url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
        params: newparams
      })
    );
    dispatch(setSortOrderType({id:null, type:null}));
    sessionStorage.removeItem('selectedRows');
    // if(params.candidateTeamId === '0'){
    // setTeamAssignEnableBtn(true);
    // } else {
    // setTeamAssignEnableBtn(false);
    // }
  };

  // useEffect(() => {
  //   if(params.candidateTeamId === '0'){
  //     setTeamAssignEnableBtn(false);
  //     } else {
  //     setTeamAssignEnableBtn(true);
  //     }
  // },[params.candidateTeamId])

  const bestmatch = (target) => {
    const newparams = {
      ...params,
      IsBestMatch: target.checked,
      jobShiftUniqueId: matchingJobid,
      jobsClaimId: jobsClaimId ? jobsClaimId : 0,
    };
    setForm({
      ...params,
      IsBestMatch: target.checked,
      jobShiftUniqueId: matchingJobid,
      jobsClaimId: jobsClaimId ? jobsClaimId : 0,
    });
    dispatch(
      getMatchingCandidateDetail({
        url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
        params: newparams,
      })
    );
  };

  const postJob = () => {
    // selectedData
    const selectedRows = storage.getItem('selectedRows')
      ? storage.getItem('selectedRows')
      : [];
    // setPostjobData(selectedRows);
    setPostjobData(selectedRows);
    const body = createPostPayload(selectedRows);
    const orderIDes =
      shiftOrderSelectedData['data']?.['columns']?.['column-2']?.orderIds;
    if (shiftOrderSelectedData['form'].authorizedUser) {
      if (!body?.candidatesInfo?.length) {
        Toasts.error(`No candidates available to post the shift`);
        return
      }
      savePostJob(body);
    } else if (orderIDes && orderIDes.includes('1')) {
      if (selectedRows.length === 0) {
        Toasts.error('Please Select candidates');
      } else {
        let flag = false;
        selectedRows.map((item) => {
          if (
            item.status !== 'IN Authorized' &&
            item.status !== 'EX Authorized'
          ) {
            Toasts.error(
              ' Please select an authorized candidate to post job'
            );
            flag = true;
            return;
          }
          else if (item?.isCandidateOverlapingShift  || !item.payRateSetupFlag) {
            // else if (item?.isCandidateOverlapingShift || !item.bankDetailsFlag || !item.payRateSetupFlag) {
            Toasts.error(
              'No candidates available to post the shift'
            );
            flag = true;
            return;
          }
          // else if (!item.bankDetailsFlag) {
          //   Toasts.error(
          //     'Please select bank detail filled candidate to post job'
          //   );
          //   flag = true;
          //   return;
          // } else if (!item.payRateSetupFlag) {
          //   Toasts.error(
          //     'Please select pay rate filled candidate to post job'
          //   );
          //   flag = true;
          //   return;
          // }
        });
        if (!flag) {
          savePostJob(body);
        }
      }
    } else {
      if (!body?.candidatesInfo?.length) {
        Toasts.error(`No candidates available to post the shift`);
        return
      }
      savePostJob(body);
    }
  };
  const getName = (authorizedStatus, isMentor, favs, ratings, orderName) => {
    let shiftOrderName = '';
    const ratingName = `${Math.round(ratings)} ${(Math.round(ratings) === 0 || Math.round(ratings) === 1) ? 'star' : 'stars'}`
    if (authorizedStatus === "EX" || authorizedStatus === "IN") {
      shiftOrderName += authorizedStatus?.toLowerCase();
    }
    if (shiftOrderName) {
      if (favs && orderName?.indexOf(`${shiftOrderName} fav`) >= 0) {
        shiftOrderName += " fav"
      } else if(isMentor && orderName?.indexOf(`${shiftOrderName} mentor`) >= 0){
        shiftOrderName += " mentor"
      }
      else if (ratings >= 0) {
        if (orderName?.indexOf(`${shiftOrderName} ${ratingName}`) >= 0) {
          shiftOrderName += ` ${ratingName}`
        }
      }
    }
    return shiftOrderName;
  }
  const createPostPayload = (selectedData) => {
    const orderIDes =
      shiftOrderSelectedData['data']?.['columns']?.['column-2']?.orderIds;
    // console.log({orderIDes});
    const orderIdsName = [];
    shiftReleaseOderList?.forEach(orderList => {
      if (orderIDes?.indexOf(orderList?.id?.toString()) >= 0) {
        orderIdsName.push(orderList?.name?.toLowerCase())
      }
    })
    const newVal = [];
    tableData.forEach((item) => {
      // if (!item.isCandidateOverlapingShift && item?.bankDetailsFlag && item.payRateSetupFlag && item?.status?.toLowerCase() !== "authorization hold") {
        if (!item.isCandidateOverlapingShift  && item.payRateSetupFlag && item?.status?.toLowerCase() !== "authorization hold") {
        if (shiftOrderSelectedData?.form?.authorizedUser) {
          // console.log("aauuuuuthhh");
          newVal.push({
            candidateUniqueId: item.candidateUniqueId,
            candidateStatus: item.statusId,
            distance: item.distance,
            name: item.name,
          });
          return
        } else if (orderIDes?.length > 0) {
          // console.log("orderID");
          const getNameOfCandi = getName(item?.inExAuthorized,item?.isMentor, item?.isFavorite, item?.ratings, orderIdsName)
          // console.log({getNameOfCandi});
          if (orderIdsName?.indexOf(getNameOfCandi) >= 0) {
            newVal.push({
              candidateUniqueId: item.candidateUniqueId,
              candidateStatus: item.statusId,
              distance: item.distance,
              name: item.name,
            });
          }
          return
        } else {
          // console.log("elseee");
          newVal.push({
            candidateUniqueId: item.candidateUniqueId,
            candidateStatus: item.statusId,
            distance: item.distance,
            name: item.name,
          });
        }

      }
    });
    // shiftReleaseOderList
    // console.log({ tableData, orderIDes, orderIdsName, newVal, shiftOrderSelectedData });

    const candidate = [];
    selectedData.forEach((item) => {
      if (!item.isCandidateOverlapingShift) {
        candidate.push({
          candidateUniqueId: item.candidateUniqueId,
          candidateStatus: item.statusId,
        });
      }
    });
    const body = {
      jobShiftUniqueId: matchingJobid,
      jobUniqueId: jobUniqueId,
      locationId: locationId,
      candidatesInfo: newVal,
      jobPosting: {
        releaseTimeIntervalInMinutes: shiftOrderSelectedData['form']?.time
          ? shiftOrderSelectedData['form'].time
          : 0,
        releaseToAllAuthorized: shiftOrderSelectedData['form']?.authorizedUser
          ? shiftOrderSelectedData['form']?.authorizedUser
          : false,
        filterDistanceUpto: params.distance,
        filterMatchingCriteria: params.candidateTeamId ? null : params.matchingCriteria,
        filterIsBestMatch: params.IsBestMatch,
      },
      jobPostingPriorities: {
        jobShiftReleaseOrderIds: orderIDes ? orderIDes : [],
      },
      jobPostingPriorityCandidates: {
        candidatesShortInfo: candidate,
      },
      jobsClaimId: jobsClaimId
        ? jobInfo?.shiftType === 3
          ? 0
          : jobsClaimId
        : 0,
    };

    return body;
  };

  const postJobAuthorizedUsers = (body) => {
    if (noOfShiftNeeded < 1) {
      // Single Job Post
      dispatch(
        sendPostJob({
          url: `${config.baseUrl}/Employers/jobs-matching-candidates`,
          params: body,
        })

      ).then((response) => {
        if (response?.result > 0) {
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false)
          navigate('/openshifts');
          Toasts.success(response?.message);
        } else {
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false)
          navigate('/openshifts');
          Toasts.error(response?.message);
        }
      });
    } else {
      // Multiple Jobs Posted
      dispatch(
        sendPostMultipleJobs({
          url: `${config.baseUrl}/Employers/multiplejobs-posting`,
          params: {
            ...body,
            jobCount: parseInt(noOfShiftNeeded),
            jobsShiftId: null
          },
        })
      ).then((response) => {
        if (response?.result > 0) {
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false)
          navigate('/openshifts');
          Toasts.success(response?.message);
        } else {
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false)
          navigate('/openshifts');
          Toasts.error(response?.message);
        }
      });
    }

  }

  const savePostJob = (body) => {
    if (jobInfo?.isClaimed && jobInfo?.shiftType !== 3) {
      setShowModal(!showModal);
    } else {
      if (jobInfo?.isPosted) {
        setRepostModal(!showRepostModal);
      } else {
        if (jobInfo?.isOvertimeAllowed) {
          postJobAuthorizedUsers(body);
        } else {
          const overtimeParams = {
            candidateUniqueId: body?.candidatesInfo?.map((item) => item?.candidateUniqueId),
            jobsShiftUniqueId: jobInfo?.jobsShiftUniqueId,
            locationId: locationId,
            jobsClaimId: 0,
          };
          dispatch(getOvertimeDetails({ url: `${config.baseUrl}/Employers/get-multicandidate-overtime-details`, params: overtimeParams, }))
            .then((response) => {
              if (response?.length) {
                const isAllowedToClaim = response?.every((candi) => candi?.isAllowedToClaim);
                if (isAllowedToClaim) {
                  postJobAuthorizedUsers(body);
                } else {
                  const newCandidatesInfo = []
                  body?.candidatesInfo?.forEach((candiInfo, index) => {
                    console.log({ inde: response?.[index]?.isAllowedToClaim });
                    // if(response&& response[index]?.isAllowedToClaim){
                    //   return {...candiInfo,allowOverwrite:true}
                    // } else {
                    //      return {...candiInfo,allowOverwrite:false}
                    // }
                    response?.forEach(item => {
                      if (candiInfo?.candidateUniqueId === item?.candidateUniqueId) {
                        if (item?.isAllowedToClaim) {
                          newCandidatesInfo.push({ ...candiInfo, allowOverwrite: true })
                        } else {
                          newCandidatesInfo.push({ ...candiInfo, allowOverwrite:false  })
                        }
                      }
                    })
                  })
                  setPostJobResponseModal(prev => ({ ...prev, type: "post", "status": !postJobResponseModal.status, "response": response, params: { ...body, candidatesInfo: newCandidatesInfo } }))
                }
              }
            });
        }
        // Number of shifts More then one or less then one bellow Call the API

      }
    }
  };

  const editJob = () => {
    dispatch(resetJobOpportunityInfo()).then(() => {
      dispatch(editPost()).then(() => {
        dispatch(setJobId(jobUniqueId)).then(() => {
          dispatch(setAcceptableDistance(acceptableTravelDistance)).then(() => {
            navigate('/jobopportunity', {
              state: {
                fromMatchingCandidate: false,
                postion:{
                  "newPost": false,
                  "fromTemplate": false,
                  "createTemplate": false,
                  "editJobPost": true
              }
              }
            });
          });
        });
      });
    });
  };

  const updateDropVal = (target) => {
    setForm({
      ...params,
      [target.name]: target.value,
    });
  };

  const teamsUpdateVal = (target) => {
    setForm({
      ...params,
      matchingCriteria: '',
      distance: '0',
      [target.name]: target.value,
    });
    const teamAssignParams = {
      ...params,
      matchingCriteria: '',
      distance: '0',
      [target.name]: target.value,
    }

    dispatch(
      getMatchingCandidateDetail({
        url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
        params: teamAssignParams,
      })
    )
  }

  useEffect(() => {
    if (params.candidateTeamId === "0") {
      sessionStorage.removeItem("selectedRows")
    }
  }, [params.candidateTeamId])

  useEffect(() => {
    if (params.candidateTeamId !== '0') {
      storage.setItem('selectedRows', tableData);
    }
  }, [tableData])



  const updateStstusDropVal = (target) => {
    if (target.action === 'add') {
      setForm({
        ...params,
        [target.name]: params[target.name].length
          ? [...params[target.name], target.value]
          : [target.value],
      });
    } else if (target.action === 'remove') {
      const newData = params[target.name].filter(
        (item) => item.id !== target.value.id
      );
      setForm({
        ...params,
        [target.name]: [...newData],
      });
    }
  };

  const updateVal = (target) => {
    if (target.validity.valid) {
      setForm({
        ...params,
        [target.name]: target.value,
      });
    }
  };

  useEffect(() => {
    if (Object.keys(rowData).length) {
      navigate('/candidatesearchview', {
        state: {
          userData: rowData,
          loctionId: locationId,
          locationNewStatus: rowData?.statusId
        },
      });
    }
  }, [count]);

  const RoutingToCandidateView = (row) => {
    setRowData(row);
    setCount((old) => old + 1);
  };
  const [depsError, setDepsError] = useState("");
  const [isDepartmentsExist, setIsDepartmentsExist] = useState(false);
  const [initialDepartmentList, setInitialDepartmentList] = useState([]);
  // departments
  const depsUnitsMaster = useSelector((store) => store.login.depsUnitsMaster);
  const getFilterElements = (selectedValue, masterValue) => {
    const filterDepartments = [];
    const idSets = new Set(masterValue?.map(item => item?.id));
    selectedValue?.forEach(deps => {
      if (idSets?.has(deps?.candidateDepartmentId)) {
        filterDepartments?.push({ id: deps?.candidateDepartmentId, name: deps?.departmentName })
      }
    });
    dispatch(setValue({ name: "depsUnits", value: filterDepartments }))
    setInitialDepartmentList(selectedValue?.map(item => item?.candidateDepartmentId));
    if (selectedValue?.length) {
      setIsDepartmentsExist(true)
    } else {
      setIsDepartmentsExist(false)
    }
  }
  const showDepartmentsHandler = (element) => {
    dispatch(getMappedDepartmentsToCandi({ baseUrl: config.baseUrl, candidateUniqueId: element?.candidateUniqueId, locationId: locationId })
    ).then((mappedCandis) => {
      if (depsUnitsMaster?.length === 0) {
        dispatch(fetchDepsUnits({ baseUrl: config.baseUrl })).then(response => {
          if (response) {
            getFilterElements(mappedCandis?.length ? mappedCandis : [], response)
          }
        })
      } else {
        getFilterElements(mappedCandis?.length ? mappedCandis : [], depsUnitsMaster)
      }
    });
    setShowDepartmentModal(prev => ({ ...prev, status: true, result: element }))
  }
  useEffect(() => {
    if (Object.keys(childarg).length) {
      const requestResponsce = {
        candidateUniqueId: childarg.row.candidateUniqueId,
        employerUniqueId: login.employerUniqueId,
        locationId: locationId,
        appUserUniqueId: login.appUserUniqueId,
        candidateStatusForEmployer: parseInt(childarg.id),
        sourceWebsite: window.location.hostname,
      };
      const currentindex = masterData.newStatusList?.findIndex(
        (item) => item.id === childarg.row.statusId
      );
      const newindex = masterData.newStatusList?.findIndex(
        (item) => item.id === parseInt(childarg.id)
      );

      setStatusrequest(requestResponsce);
      if (parseInt(childarg.id) === 99) {
        Toasts.info('Please Select Valid status other than New');
      } else if (newindex > currentindex + 1) {
        setShowStatusWaring(!showStatusWaring);
      } else {
        const newData = tableData.map((item) => {
          if (item.candidateId === childarg.row.candidateId) {
            // item.statusId = parseInt(childarg.id);
            return { ...item, statusId: parseInt(childarg.id) }
          }
          return item;
        });
        setTableData(newData);
        setSkipPageReset(true);
        if (+childarg?.id === 4 || +childarg?.id === 5) {
          showDepartmentsHandler(childarg?.row)
          return;
        }
        dispatch(
          updateStatus({
            url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
            params: requestResponsce,
          })
        ).then((response) => {
          // Clear the Session Storage for Selected Rows
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false)
          const newparams = {
            ...params,
            jobShiftUniqueId: matchingJobid,
            jobsClaimId: jobsClaimId ? jobsClaimId : 0,
          };
          dispatch(
            getMatchingCandidateDetail({
              url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
              params: newparams,
            })
          );
        });
      }
    }
  }, [childarg]);

  const changeStatus = () => {
    setShowStatusWaring(!showStatusWaring);
    if (Object.keys(statusrequest).length) {
      const newData = tableData.map((item) => {
        if (item.candidateId === childarg.row.candidateId) {
          // item.statusId = parseInt(childarg.id);
          return { ...item, statusId: parseInt(childarg.id) }
        }
        return item;
      });
      setTableData(newData);
      setSkipPageReset(true);
      if (+childarg?.id === 4 || +childarg?.id === 5) {
        showDepartmentsHandler(childarg?.row);
        return;
      }
      dispatch(
        updateStatus({
          url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
          params: statusrequest,
        })
      ).then((response) => {
        sessionStorage.removeItem('selectedRows');
        const newparams = {
          ...params,
          jobShiftUniqueId: matchingJobid,
          jobsClaimId: jobsClaimId ? jobsClaimId : 0,
        };
        dispatch(
          getMatchingCandidateDetail({
            url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
            params: newparams,
          })
        );
      });
    }
  };

  const changeheStatus = (id, row) => {
    setChildarg({ id, row });
  };

  const favoriteandUnfavorite = (data, isFavorite) => {
    //const flag = data.some((item) => item.statusId !== 3);
    const flag = data.some(
      (item) => item.statusId !== 4 && item.statusId !== 5
    );
    if (data.length === 0) {
      Toasts.info('Please Select the Candidates');
    } else {
      if (flag) {
        if (isFavorite) {
          Toasts.info('Only authorized users can be set as favorite candidates');
        } else {
          Toasts.info('You can unfavorite only Authorized Person only');
        }
      } else {
        const payload = {
          candidateUniqueIds: data.map((item) => item.candidateUniqueId),
          employerUniqueId: login.employerUniqueId,
          locationId: locationId,
          appUserUniqueId: login.appUserUniqueId,
          isFavorite: isFavorite,
        };
        dispatch(
          saveFavorite({
            url: `${config.baseUrl}/Employers/set-candidate-favorite-status`,
            params: payload,
          })
        ).then(() => {
          const newparams = {
            ...params,
            jobShiftUniqueId: matchingJobid,
            jobsClaimId: jobsClaimId ? jobsClaimId : 0,
          };
          dispatch(
            getMatchingCandidateDetail({
              url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
              params: newparams,
            })
          );
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false);
        });
      }
    }
  };

  const addMentor_RemoveMentor = (data, isFavorite) => {
    //const flag = data.some((item) => item.statusId !== 3);
    const flag = data.some(
      (item) => item.statusId !== 4 && item.statusId !== 5
    );
    if (data.length === 0) {
      Toasts.info('Please Select the Candidates');
    } else {
      if (flag) {
        if (isFavorite) {
          Toasts.info('Only authorized users can be set as mentor');
        } else {
          Toasts.info('You can remove Authorized Person only');
        }
      } else {
        const payload = {
          candidateUniqueIds: data.map((item) => item.candidateUniqueId),
          employerUniqueId: login.employerUniqueId,
          locationId: locationId,
          appUserUniqueId: login.appUserUniqueId,
          isMentor: isFavorite,
        };
        dispatch(
          saveFavorite({
            url: `${config.baseUrl}/Employers/set-candidate-mentor-status`,
            params: payload,
          })
        ).then(() => {
          const newparams = {
            ...params,
            jobShiftUniqueId: matchingJobid,
            jobsClaimId: jobsClaimId ? jobsClaimId : 0,
          };
          dispatch(
            getMatchingCandidateDetail({
              url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
              params: newparams,
            })
          );
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false)
        });
      }
    }
  };



  const createStar = (count) => {
    let color = '';
    const val = count;
    if (val > 3) {
      color = 'green';
    } else if (val > 2 && val <= 3) {
      color = 'yellow';
    } else if (val > 0 && val <= 2) {
      color = 'red ';
    } else if (val <= 0) {
      color = 'black ';
    }
    // if (val >= 4) {
    //   color = 'green';
    // } else if (val >= 3) {
    //   color = 'yellow';
    // } else if (val < 3 && val >= 0) {
    //   color = 'red ';
    // } else if (val <= 0) {
    //   color = 'black ';
    // }
    // if (val >= 4) {
    //     color = 'green';
    // } else if (val >= 3) {
    //     color = 'yellow';
    // } else if (val < 3) {
    //     color = 'red';
    // }
    const star = {
      size: 15,
      count: 5,
      value: count,
      edit: false,
      color: color,
      activeColor: color,
      a11y: true,
      isHalf: true,
      emptyIcon: <i className="fa fa-star-o" />,
      halfIcon: <i style={{ color: color }} className="fa fa-star-half-o" />,
      filledIcon: <i className="fa fa-star" />,
    };
    return <ReactStars {...star} />;
  };

  const createStarforFavoriteFalse = (flag) => {
    const star = {
      size: 20,
      count: 1,
      value: flag ? 1 : 0,
      edit: false,
      color: flag ? 'green' : 'Grey',
      activeColor: flag ? 'green' : 'Grey',
      a11y: true,
      isHalf: true,
      emptyIcon: <i className="fa fa-star-o" />,
      halfIcon: <i className="fa fa-star-half-o" />,
      filledIcon: <i className="fa fa-star" />,
    };
    return <ReactStars {...star} />;
  };

  const Createoverlays = (arrayData) => {
    const statusColorMap = {
      1: 'green',
      2: 'red',
      0: 'black',
    };
    const popover = (
      <Popover id="popover-basic">
        <Popover.Body>
          {arrayData.map((item) => (
            <div style={{ color: statusColorMap[item.isExists] }}>
              {item.name}
            </div>
          ))}
        </Popover.Body>
      </Popover>
    );

    return (
      <>
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={popover}
        >
          <span variant="success">
            {arrayData.map((item) => (
              <div
                className="criteria"
                style={{ color: statusColorMap[item.isExists] }}
              >
                {item.name}
              </div>
            ))}
          </span>
        </OverlayTrigger>
      </>
    );
  };

  const CreateoverlaysWithFileNew = (arrayData) => {
    // const renderTooltip = (props) => (
    //     <Tooltip id="button-tooltip" {...props}>

    //     </Tooltip>
    // );
    const statusColorMap = {
      1: 'green',
      2: 'red',
      0: 'black',
    };
    const popover = (
      <Popover id="popover-basic">
        <Popover.Body>
          {arrayData.map((item) => (
            <>
              <div style={{ color: statusColorMap[item.isExists] }}>
                {/* {`${item.label} - ${item.savedvalue} `} */}
                {item.label}
                {item?.isNeedAttachmentPin || item?.isNeedVText ? ` -` : ''}

                {item?.isNeedAttachmentPin && (
                  <i
                    class="fa fa-paperclip"
                    style={{ color: statusColorMap[item?.attachmentPinColor] }}
                  ></i>
                )}
                {item?.isNeedVText && (
                  <span style={{ color: statusColorMap[item?.vTextColor] }}>
                    {' '}
                    V
                  </span>
                )}
              </div>
            </>
          ))}
        </Popover.Body>
      </Popover>
    );

    return (
      <>
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={popover}
        >
          <span variant="success">
            {arrayData.map((item) => (
              <div
                className="criteria"
                style={{ color: statusColorMap[item.isExists] }}
              >
                {/* {`${item.label} - ${item.savedvalue} `} */}
                {item.label}
                {item?.isNeedAttachmentPin || item?.isNeedVText ? ` -` : ''}

                {item?.isNeedAttachmentPin && (
                  <i
                    class="fa fa-paperclip"
                    style={{ color: statusColorMap[item?.attachmentPinColor] }}
                  ></i>
                )}
                {item?.isNeedVText && (
                  <span style={{ color: statusColorMap[item?.vTextColor] }}>
                    {' '}
                    V
                  </span>
                )}
              </div>
            ))}
          </span>
        </OverlayTrigger>
      </>
    );
  };

  const CreateoverlaysForToolTip = (arrayData, arryDataToolTip) => {
    const statusColorMap = {
      1: 'green',
      2: 'red',
      0: 'black',
    };
    const popover = (
      <Popover id="popover-basic">
        <Popover.Body>
          {arryDataToolTip?.map((item) => (
            <div style={{ color: statusColorMap[item.isExists] }}>
              {item.name}
            </div>
          ))}
        </Popover.Body>
      </Popover>
    );

    return (
      <>
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={popover}
        >
          <span variant="success">
            {arrayData.map((item) => (
              <div
                className="criteria"
                style={{ color: statusColorMap[item.isExists] }}
              >
                {item.name}
              </div>
            ))}
          </span>
        </OverlayTrigger>
      </>
    );
  };

  const CreateoverlaysForIconToolTip = (icon, arryDataToolTip) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Body>
          {
            <div className='d-flex justify-content-center align-items-center'>
              {/* <div  dangerouslySetInnerHTML={{ __html: arryDataToolTip }} /> */}
              <table className='table table-responsive' dangerouslySetInnerHTML={{ __html: arryDataToolTip }}></table>
              {/* {arryDataToolTip?.map((item) => (
                <table className='table'>
                  <thead>
                    <tr><th colSpan="2">Bank Details</th></tr>
                  </thead>
                  <tbody>
                    <tr><td>Account Holder Name</td><td>{item?.accountHolderName}</td></tr>
                    <tr><td>Bank Name</td><td>{item?.bankName}</td></tr>
                    <tr><td>Account Type</td><td>{item?.accountType}</td></tr>
                    <tr><td>Bank Account Number</td><td>{item?.bankAccountNumber}</td></tr>
                    <tr><td>Bank Address</td><td>{item?.bankAddress}</td></tr>
                    <tr><td>Candidate ID</td><td>{item?.candidateId}</td></tr>
                    <tr><td>Routing Number</td><td>{item?.routingNumber}</td></tr>
                  </tbody>
                </table>
              ))} */}
            </div>
          }
        </Popover.Body>
      </Popover>
    );

    return (
      <>
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={arryDataToolTip ? popover : <span></span>}
        >
          <span variant="success">
            {icon}
          </span>
        </OverlayTrigger>
      </>
    );
  };

  const CreateoverlaysAll = (arrayData, labelFlag) => {
    const statusColorMap = {
      1: 'green',
      2: 'red',
      0: 'black',
    };
    const popover = (
      <Popover id="popover-basic">
        <Popover.Body>
          {arrayData.map((item) => (
            <div style={{ color: statusColorMap[item.isExists] }}>
              {labelFlag ? item.label : item.name}
            </div>
          ))}
        </Popover.Body>
      </Popover>
    );

    return (
      <>
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={popover}
        >
          <span variant="success">
            {arrayData.slice(0).map((item) => (
              <div
                className="criteria"
                style={{ color: statusColorMap[item.isExists] }}
              >
                {item.name}
              </div>
            ))}
          </span>
        </OverlayTrigger>
      </>
    );
  };

  const CreateoverlaysWithFile = (arrayData, popVal) => {
    // const renderTooltip = (props) => (
    //     <Tooltip id="button-tooltip" {...props}>

    //     </Tooltip>
    // );
    const statusColorMap = {
      1: 'green',
      2: 'red',
      0: 'black',
    };
    const popover =
      popVal?.length > 0 ? (
        <Popover id="popover-basic">
          <Popover.Body>
            {popVal.map((item) => (
              <>
                <div style={{ color: statusColorMap[item.isExists] }}>
                  {`${item.label} - ${item.savedvalue} `}
                  {item?.isNeedAttachmentPin && (
                    <i
                      class="fa fa-paperclip"
                      style={{
                        color: statusColorMap[item?.attachmentPinColor],
                      }}
                    ></i>
                  )}
                  {item?.isNeedVText && (
                    <span style={{ color: statusColorMap[item?.vTextColor] }}>
                      {' '}
                      V
                    </span>
                  )}
                </div>
              </>
            ))}
          </Popover.Body>
        </Popover>
      ) : (
        <span></span>
      );

    return (
      <>
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={popover}
        >
          <span variant="success">
            {arrayData.map((item) => (
              <div
                className="criteria"
                style={{ color: statusColorMap[item.isExists] }}
              >
                {`${item.label} - ${item.savedvalue} `}
                {item?.isNeedAttachmentPin && (
                  <i
                    class="fa fa-paperclip"
                    style={{ color: statusColorMap[item?.attachmentPinColor] }}
                  ></i>
                )}
                {item?.isNeedVText && (
                  <span style={{ color: statusColorMap[item?.vTextColor] }}>
                    {' '}
                    V
                  </span>
                )}
              </div>
            ))}
          </span>
        </OverlayTrigger>
      </>
    );
  };

  const dollarRef = useRef(null);
  const [dollarOpen, setDollarOpen] = useState({ status: false, serialNo: null, result: [] })
  const handleOutsideClick = () => {
    // console.log('Clicked outside!');
    setDollarOpen({ status: false, serialNo: null, result: [] })
  };
  useOutsideClick(dollarRef, handleOutsideClick);

  const getDollarDetails = (data) => {
    const { serialNo, jobInfo, candidateId, departmentsList } = data;
    const deptIdList = departmentsList ? departmentsList?.map((item) => item?.candidateDepartmentId) : []
    const params = {
      candidateId,
      jobShiftUniqueId: jobInfo?.jobsShiftUniqueId,
      candidateDepartmentId: deptIdList
    }
    if (dollarOpen?.serialNo !== serialNo) {
      dispatch(fetchDollarDetails({ url: `${config.baseUrl}/Employers/candidates-payrate-setup`, params })).then(response => {
        setDollarOpen(prev => ({ ...prev, status: true, serialNo, result: response ?? [] }))
      })
    }
  }
  // console.log({dollarOpen});
  const updateStatusOfEmployer = (hasDepartment,showErrorMsg) => {
    if(hasDepartment){
      dispatch(
        updateStatus({
          url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
          params: statusrequest,
        })
      ).then((response) => {
        sessionStorage.removeItem('selectedRows');
        const newparams = {
          ...params,
          jobShiftUniqueId: matchingJobid,
          jobsClaimId: jobsClaimId ? jobsClaimId : 0,
        };
        dispatch(
          getMatchingCandidateDetail({
            url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
            params: newparams,
          })
        );
      });
    } else {
      if(showErrorMsg){
        setShowErrorModal(true);
      }
      const copyTableData = [...tableData];
      const newData = copyTableData?.map(data => {
        if( data?.candidateUniqueId === childarg?.row?.candidateUniqueId){
          return childarg.row
        }
        return data;
      });
      setTableData(newData);
    }
  };
  const updateEmpDepStatus = ({ mappedParams, isDepartmentsExist }) => {
    dispatch(
      updateStatus({
        url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
        params: statusrequest,
      })
    ).then((response) => {
      if (response) {
        dispatch(mapDepartmentsToCandidate({ baseURL: config.baseUrl, mappedParams })).then((response) => {
          if (!isDepartmentsExist && !response) {
            dispatch(
              updateStatus({
                url: `${config.baseUrl}/Employers/updatecandidatestatusforemployer`,
                params: {
                  ...statusrequest,
                  candidateStatusForEmployer: childarg.row?.statusId,
                },
              })
            ).then((response) => {
              if(response){
                updateStatusOfEmployer(false, true);
              }
            });
          } else {
            const newparams = {
              ...params,
              jobShiftUniqueId: matchingJobid,
              jobsClaimId: jobsClaimId ? jobsClaimId : 0,
            };
            dispatch(
              getMatchingCandidateDetail({
                url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
                params: newparams,
              })
            );
          }
        });
      } else {
        updateStatusOfEmployer(false);
      }
    });
  };
  const handleSort = (sortType, sortColumn) => {
    if(sortColumn){
      const newparams = {
        ...params,
        jobShiftUniqueId: matchingJobid,
        distance: acceptableTravelDistance,
        jobsClaimId: jobsClaimId ? jobsClaimId : 0,
        sortOrder: sortType,
        sortColumn: sortType ? sortColumn : "",
      };
      dispatch(
        getMatchingCandidateDetail({
          url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
          params: newparams,
        })
      ).then(response => {
        const sortOrderTypeObj = {id:sortType ? sortColumn : "", type:sortType};
        dispatch(setSortOrderType(sortOrderTypeObj));
        setForm(newparams);
      })
      };
  }
  const newColumn = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'serialNo',
        id: 'serialNo',
        disableSortBy: true,
      },
      {
        Header: <div className="mx-1"><i class="fa fa-eye"></i></div>,
        accessor: 'view',
        tipText: "View",
        id: 'view',
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <button
              id="bAcep"
              type="button"
              className="btn  btn-sm"
              title="View Contacts"
              onClick={() => RoutingToCandidateView(row.original)}
            >
              <span className="fa fa-eye"> </span>
            </button>
          );
        },
      },
      {
        Header: 'Status',
        accessor: 'status',
        // tipText: "Status",
        id: 'status',
        Cell: ({ row }) => {
          return (
            <select
              value={row.original.statusId}
              name="status"
              onChange={(e) => {
                changeheStatus(e.target.value, row.original);
              }}
            >
              {masterData.newStatusList.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          );
        },
      },
      {
        Header: 'Name',
        accessor: 'name',
        id: 'name',
        Cell: ({ row }) => {
          const statusColorMap = {
            1: 'green',
            2: 'red',
            0: 'black',
            3: '#0078D4' //Blue  
          };

          var changeColor = 0;

          if (row.original.isCandidateOverlapingShift || row.original.isOvertimeAllowance) {
            changeColor = 2;
            // } else if (row.original?.isAuthorizedForAllLocations) {
          } else if (row.original?.status === "EX Authorized" || row.original?.status === "IN Authorized") {
            if (!row.original?.isAuthorizedForAllLocations) {
              changeColor = 3;
            }
          }
          return (
            <span style={{ color: statusColorMap[changeColor] }}>
              {row.original.isCandidateOverlapingShift === true || row.original.isOvertimeAllowance === true || !row.original.isAuthorizedForAllLocations === true ?
                row.original.candidateOverlap.length > 0 ?
                  <ToolTip
                    position={"left"}
                    value={row.original.candidateOverlap.length > 0 ? row.original.candidateOverlap?.map((item) =>
                      <span>{item.name}<br /></span>
                    ) : ''}
                  >
                    <p style={{ cursor: 'pointer' }}>{row.original.name}</p>
                  </ToolTip> : <p style={{ cursor: 'pointer' }}>{row.original.name}</p>

                :
                <span>{row.original.name}</span>
              }
            </span>

          );
        },
      },
      {
        Header: "Phone",
        accessor: "phone",
        disableSortBy: true,
        maxWidth:"12px",
        Cell: ({ row }) => {
          return (
            <div className='d-flex'>
               <span onClick={() => showCallModal(row.original)} className='connection'>
                  <i
                    class="fe fe-phone-call"
                    style={{
                      color: "#fff",
                      fontWeight: '500',
                      fontSize: '18px'
                    }}
                  ></i>
                </span>
            </div>
            // <div style={{ width: "200px" }} className='d-flex gap-2'>
            //   <div style={{display: 'inline-block'}}>
            //     <span onClick={() => showCallModal(row.original)} className='connection'>
            //     <i
            //       class="fe fe-phone-call"
            //       style={{
            //         color: "#fff",
            //         fontWeight: '500',
            //         fontSize: '18px'
            //       }}
            //     ></i>
            //   </span>
            //   </div>
            //   {" "}
            //   <span>
            //   <span onClick={() => showSmsModal(row.original)} className='connection'>
            //       <i
            //         class="fa fa-commenting"
            //         style={{
            //           color: "#fff",
            //           fontWeight: '500',
            //           fontSize: '18px'
            //         }}
            //       ></i>
            //     </span>
            //     {row.original.phone}
            //   </span>
            //   {/* <span onClick={() => showSmsModal(row.original)} className='connection'>
            //     <i
            //       className="fa fa-comment-o"
            //       style={{
            //         color: "#fff",
            //         fontWeight: '500',
            //         fontSize: '18px'
            //       }}

            //     ></i>
            //   </span> */}

            // </div>
          );
        },
      },
      {
        Header: "SMS",
        accessor: "sms",
        disableSortBy: true,
        maxWidth:"12px",
        Cell: ({ row }) => {
          return (
            <div className='d-flex'>
               <span onClick={() => showSmsModal(row.original)} className='connection'>
                  <i
                    class="fa fa fa-commenting-o"
                    style={{ fontSize: '18px', cursor: "pointer", color: "#fff" }}
                  ></i>
                </span>
            </div>
          );
        },
      },
      {
        Header: "Email",
        accessor: "email",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <div  className='d-flex '>
               <span onClick={() => showEmailModal(row.original)} className='connection'>
                  <i
                    class="ti-email"
                    style={{
                      color: "#fff",
                      fontWeight: '500',
                      fontSize: '18px'
                    }}
                  ></i>
                </span>
            </div>
          );
        },
      },
      {
        Header: <div className="d-flex flex-column"><label>Preferred</label><label>Shift Time</label></div>,
        accessor: 'preferredShiftTimeOfTheDayList',
        id: 'preferredShiftTimeOfTheDayList',
        Cell: ({ row }) => {
          return row?.original?.preferredShiftTimeOfTheDayList?.length > 0
            ? CreateoverlaysForToolTip(
              row?.original?.preferredShiftTimeOfTheDayList,
              row?.original?.preferredShiftTimeOfTheDayList
            )
            : '';
        },
      },
      {
        Header: <i class="fa fa-car"></i>,
        id: "relocate",
        accessor: "relocate",
        tipText: "Relocate",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <span>
              {row.original.relocate === true
                ? (
                  <i
                    class="fa fa-car"
                    style={{ color: "green", fontSize: "18px" }}
                  >
                  </i>
                )
                : (
                  ""
                )}
            </span>
          );
        },
      },

      {
        Header: <div className="d-flex flex-column"><label>EX</label><label>IN</label></div>,
        accessor: 'inExAuthorized',
        tipText: "EX IN",
      },
      {
        Header: <i class="fa fa-bank" style={{ fontSize: '20px' }}></i>,
        id: "bank",
        accessor: "bank",
        tipText: "Bank",
        disableSortBy: true,
        Cell: ({ row }) => {
          //row.original?.bankDetailsList
          let data = ''
          row.original?.bankDetailsList?.map((item) => (
            data = data + (`
              <table className='table'>
                <thead>
                  <tr><th colSpan="2">Bank Details</th></tr>
                </thead>
                <tbody>
                  <tr><td>Account Holder Name</td><td>${item?.accountHolderName}</td></tr>
                  <tr><td>Bank Name</td><td>${item?.bankName}</td></tr>
                  <tr><td>Account Type</td><td>${item?.accountType}</td></tr>
                  <tr><td>Bank Account Number</td><td>${item?.bankAccountNumber}</td></tr>
                  <tr><td>Bank Address</td><td>${item?.bankAddress}</td></tr>
                  <tr><td>Candidate ID</td><td>${item?.candidateId}</td></tr>
                  <tr><td>Routing Number</td><td>${item?.routingNumber}</td></tr>
                </tbody>
              </table>`)
          ))
          const icon =
            <i
              class="fa fa-bank fa-lg"
              style={{ color: row.original?.bankDetailsFlag === true ? "green" : "red" }}
            >
            </i>
          // (CreateoverlaysForIconToolTip(icon, data));
          return (icon);
        },
      },
      {
        Header: <i class="fa fa-money" style={{ fontSize: '22px' }}></i>,
        id: "dollor",
        accessor: "dollor",
        tipText: "Payrate",
        disableSortBy: true,
        Cell: ({ row }) => {
          let data = `<table className='table'>
          <thead>
          <tr>
          <th style="text-transform: capitalize; text-align: center;">Location</th>
          <th style="text-transform: capitalize; text-align: center;">Candidate hourly <br/> base rate</th>
          <th style="text-transform: capitalize; text-align: center;">Employer billing <br/> markup</th>
          <th style="text-transform: capitalize; text-align: center;">Employer hourly <br/> base rate</th>
          </tr>
          </thead><tbody>`
          let tr = ''
          row.original?.candidatePayRateSetupList?.map((item) => (
            tr = tr + (`
            <tr className="border-bottom mt-2 bg-white"><td>${item?.locationName}</td>
            <td style="text-transform: capitalize; text-align: center;">${item?.hasRatePerHour}</td>
            <td style="text-transform: capitalize; text-align: center;">${item?.markup}</td>
            <td style="text-transform: capitalize; text-align: center;">${(parseFloat(item?.hasRatePerHour) * parseFloat(item?.markup)).toFixed(2)}</td>
            </tr>
                  `)
          ))
          data = data + tr + `</tbody></table>`;

          // Encounter Payrate Details List
          let EncounterData = `<table className='table'>
          <thead>
          <tr>
          <th style="text-transform: capitalize; text-align: center;">Location</th>
          <th style="text-transform: capitalize; text-align: center;">Appointment type</th>
          <th style="text-transform: capitalize; text-align: center;">Candidate hourly <br/> base rate</th>
          <th style="text-transform: capitalize; text-align: center;">Employer hourly <br/> base rate</th>
          </tr>
          </thead><tbody>`
          let Entr = ''
          row.original?.candidatePayRateSetupList?.map((item) => (
            Entr = Entr + (`
            <tr className="border-bottom mt-2 bg-white"><td>${item?.locationName}</td>
            <td style="text-transform: capitalize; text-align: center;">${item?.appointmentTypes}</td>
            <td style="text-transform: capitalize; text-align: center;">${item?.hasRatePerHour}</td>
            <td style="text-transform: capitalize; text-align: center;">${item?.employerHasRatePerHour}</td>
            </tr>
                  `)
          ))
          EncounterData = EncounterData + Entr + `</tbody></table>`;

          const icon =
            <i
              class="fa fa-money"
              style={{ color: row.original?.payRateSetupFlag === true ? "green" : "red", fontSize: '22px' }}
            >
            </i>
          return <div className="custom-overlay">
            <div className="custom-trigger  ps-0 pe-0 " onClick={() => getDollarDetails(row.original)}>
              <i class="fa fa-money" style={{ color: row.original?.payRateSetupFlag === true ? "green" : "red", fontSize: '22px' }}>
              </i>
            </div>
            {
              (dollarOpen?.status && dollarOpen?.serialNo === row.original?.serialNo) &&
              <div className="custom-popover" id="customPopover" style={{ 'zIndex': 999999 }}>
                <table ref={dollarRef} className='table '>
                  <thead>
                    <tr>
                      <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Location</th>
                      <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Department <br /> name</th>
                      {row.original?.shiftType === 2 &&
                        <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Appointment type</th>}
                      <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Candidate hourly <br /> base rate</th>
                      {row.original?.shiftType !== 2 &&
                        <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Employer billing <br /> markup</th>}
                      <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Employer hourly <br /> base rate</th>
                      <th style={{ textTransform: "capitalize", textAlign: "center", fontWeight: "600" }}>Effective Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      Array.isArray(dollarOpen?.result) && dollarOpen?.result?.length > 0 && dollarOpen?.result?.map((item, index) => (
                        <tr key={index} className="border-bottom mt-2 bg-white" style={{ color: item?.colourCode ? "green" : "red" }}>
                          <td style={{ textTransform: "capitalize", textAlign: "center" }}>{item?.locationName}</td>
                          <td style={{ textTransform: "capitalize", textAlign: "center" }}>{item?.departmentName}</td>
                          {row.original?.shiftType === 2 &&
                            <td style={{ textTransform: "capitalize", textAlign: "center" }}>${item?.appointmentTypes}</td>
                          }
                          <td style={{ textTransform: "capitalize", textAlign: "center" }}>{item?.hasRatePerHour ? `$${item?.hasRatePerHour}` : ""}</td>
                          {row.original?.shiftType !== 2 &&
                            <td style={{ textTransform: "capitalize", textAlign: "center" }}>{item?.markup ? item?.markup : ""}</td>}
                          <td style={{ textTransform: "capitalize", textAlign: "center" }}>
                            {/* ${(parseFloat(item?.hasRatePerHour) * parseFloat(item?.markup)).toFixed(2)} */}
                            {item?.hasRatePerHour ? `$${(
                              parseFloat(item?.hasRatePerHour) *
                              parseFloat(item?.markup)
                            ).toFixed(2)}` : ""}
                          </td>
                          <td>
                            {/* {(item?.colourCode && item?.effectiveDate ) ? moment(item?.effectiveDate).format("MM/DD/YYYY") :"" } */}
                            {(item?.effectiveDate && ((row.original?.shiftType === 2 && item?.employerHasRatePerHour && item?.hasRatePerHour) ||
                              (row.original?.shiftType !== 2 && item?.hasRatePerHour && item?.markup)))
                              ? moment(item?.effectiveDate).format("MM/DD/YYYY")
                              : ""}
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
          // return (CreateoverlaysForIconToolTip(icon, row.original?.candidatePayRateSetupList?.length ? row?.original?.jobInfo?.shiftType === 2 ? EncounterData : data : ''));
        },
      },
      // {
      //   Header: <i class="fa fa-dollar" style={{ fontSize: '18px', width: '50px' }}></i>,
      //   accessor: 'ratePerHourToDisplay',
      //   disableSortBy: true,
      //   Cell: ({ row }) => {
      //     return <span >{row.original.ratePerHourToDisplay}</span>
      //   },
      // },
      {
        Header: 'Distance',
        accessor: 'distance',
        Cell: ({ row }) => {
          return <span style={{ color: `${row.original.colorcodeForDistance ? 'green' : ''}` }}>{row.original.distance + ' miles'}</span>
        },
      },
      {
        Header: <div className="d-flex flex-column"><label>Preferred</label><label>Distance</label></div>,
        accessor: 'preferedDistanceName',
        id: 'preferedDistanceName',
        Cell: ({ row }) => {
          return row.original.preferredDistance?.length > 0
            ? Createoverlays(row.original.preferredDistance)
            : '';
        },
      },
      {
        Header: 'Hours Worked',
        accessor: 'hoursWorked',
      },
      {
        Header: 'Shifts Completed',
        accessor: 'shiftsCompleted',
        disableSortBy: true,
      },
      {
        Header: 'City',
        accessor: 'city',
        disableSortBy: true,
      },
      {
        Header: 'State',
        accessor: 'state',
        disableSortBy: true,
      },
      {
        Header: 'Zip',
        accessor: 'zipcode',
        disableSortBy: true,
      },
      {
        Header: 'Level',
        accessor: 'jobCategoryName',
        id: 'jobCategoryName',
        Cell: ({ row }) => {
          return row.original.jobCategory?.length > 0
            ? CreateoverlaysForToolTip(
              row.original.jobCategory,
              row.original.jobInfo.listJobLevel
            )
            : '';
        },
      },
      {
        Header: 'Departments',
        accessor: 'departmentsList',
        id: 'candidatesdepartmentlist',
        // disableSortBy: true,
        Cell: ({ row }) => {
          return row?.original?.departmentsList?.length ?
            Createoverlays(row?.original?.departmentsList) : ""
        },
      },
      {
        Header: 'Certifications',
        accessor: 'certificationsName',
        id: 'certificationsName',
        disableSortBy: true,
        Cell: ({ row }) => {
          return row.original.certificationsListWithAttachment?.length > 0
            ? CreateoverlaysWithFileNew(
              row.original.certificationsListWithAttachment
            )
            : '';
        },
      },
      {
        Header: 'Specialties',
        accessor: 'specialtyName',
        id: 'specialtyName',
        disableSortBy: true,
        Cell: ({ row }) => {
          return row.original.specialtyList?.length > 0
            ? CreateoverlaysForToolTip(
              row.original.specialtyList,
              row.original.jobInfo.listJobsSpecialty
            )
            : '';
        },
      },
      {
        Header: 'EMR/EHR',
        accessor: 'emrehrSystemName',
        id: 'emrehrSystemName',
        disableSortBy: true,
        Cell: ({ row }) => {
          return row.original.emrehrSystemList?.length > 0
            ? CreateoverlaysForToolTip(
              row.original.emrehrSystemList,
              row.original.jobInfo.listJobsEmrehrsystem
            )
            : '';
        },
      },
      {
        Header: 'Education',
        accessor: 'levelofEducation',
        id: 'levelofEducation',
        Cell: ({ row }) => {
          return row.original.levelofEducationList?.length > 0
            ? CreateoverlaysForToolTip(
              row.original.levelofEducationList,
              row.original.jobInfo.listLevelOfEducation
            )
            : '';
        },
        // Cell: ({ row }) => {
        //     const statusColorMap = {
        //         1: 'green',
        //         2: 'red',
        //         0: 'black'
        //     }
        //     return <span style={{ color: statusColorMap[row.original.isEducationExists] }}>{row.original.levelofEducation}</span>
        // }
      },
      {
        Header: 'Shift',
        accessor: 'preferredShiftName',
        id: 'preferredShiftName',
        disableSortBy: true,
        Cell: ({ row }) => {
          return row.original.preferredShiftList?.length > 0
            ? CreateoverlaysForToolTip(
              row.original.preferredShiftList,
              row.original.jobInfo.listPreferredShift
            )
            : '';
        },
      },
      {
        Header: 'Vaccine',
        accessor: 'covid19Vaccinated',
        id: 'covid19Vaccinated',
        Cell: ({ row }) => {
          return row.original.covid19VaccinatedList?.length > 0
            ? CreateoverlaysForToolTip(
              row.original.covid19VaccinatedList,
              row.original.jobInfo.listCovid19Vaccinated
            )
            : '';
        },
        // Cell: ({ row }) => {
        //     const statusColorMap = {
        //         1: 'green',
        //         2: 'red',
        //         0: 'black'
        //     }
        //     return <span style={{ color: statusColorMap[row.original.isCovid19VaccinatedExists] }}>{row.original.covid19Vaccinated}</span>
        // }
      },
      {
        Header: 'Languages',
        accessor: 'spokenLanguagesList',
        id: 'spokenlanguage',
        // disableSortBy: true,
        Cell: ({ row }) => {
          return row.original.spokenLanguagesList?.length > 0
            ? CreateoverlaysForToolTip(
              row.original.spokenLanguagesList,
              row.original.jobInfo.listJobsSpokenLanguage
            )
            : '';
        },
      },


      {
        Header: 'Experience and Skills',
        accessor: 'ExperienceandSkills',
        id: 'ExperienceandSkills',
        disableSortBy: true,
        Cell: ({ row }) => {
          const filterData = row?.original?.columnInfo?.filter(
            (item) => item.columnName === 'ExperienceandSkills'
          );
          return filterData?.length > 0 && filterData[0].values
            ? CreateoverlaysWithFile(
              filterData[0].values,
              filterData[0].listMatchingJobsDynamicControlPopup
            )
            : '';
        },
      },
      {
        Header: 'Certificates/Permits/Licenses/Training Section 1',
        accessor: 'CertificatesPermitsLicensesTrainingSection1',
        id: 'CertificatesPermitsLicensesTrainingSection1',
        disableSortBy: true,
        Cell: ({ row }) => {
          const filterData = row?.original?.columnInfo?.filter(
            (item) =>
              item.columnName === 'CertificatesPermitsLicensesTrainingSection1'
          );
          return filterData?.length > 0 && filterData[0].values
            ? CreateoverlaysWithFile(
              filterData[0].values,
              filterData[0].listMatchingJobsDynamicControlPopup
            )
            : '';
        },
      },
      {
        Header: 'Certificates/Permits/Licenses/Training Section 2',
        accessor: 'CertificatesPermitsLicensesTrainingSection2',
        id: 'CertificatesPermitsLicensesTrainingSection2',
        disableSortBy: true,
        Cell: ({ row }) => {
          const filterData = row?.original?.columnInfo?.filter(
            (item) =>
              item.columnName === 'CertificatesPermitsLicensesTrainingSection2'
          );
          return filterData?.length > 0 && filterData[0].values
            ? CreateoverlaysWithFile(
              filterData[0].values,
              filterData[0].listMatchingJobsDynamicControlPopup
            )
            : '';
        },
      },

      {
        Header: <svg
        width="12"
        height="19"
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon
          points="10,190 10,10 60,10 100,90 140,10 190,10 190,190 150,190 150,60 100,140 50,60 50,190"
          fill={"white"}
          stroke="black"
          stroke-width={"1.5rem"}
        />
      </svg>,
        id: "isMentor",
        tipText: 'Mentor',
        accessor: "isMentor",
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <span>
              <Mentor fillColor={row.original.isMentor ? 'green' : 'white'}/>
            </span>
          );
        },
      },

      {
        Header: <label><i class="fa fa-star-o"></i></label>,
        id: 'isFavorite',
        tipText: "Favorite",
        accessor: 'isFavorite',
        disableSortBy: true,
        Cell: ({ row }) => {
          return (
            <span>{createStarforFavoriteFalse(row.original.isFavorite)}</span>
          );
        },
      },
      {
        Header: <label><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i><i class="fa fa-star-o"></i></label>,
        accessor: 'ratings',
        id: 'ratings',
        tipText: "Ratings",
        // disableSortBy: true,
        Cell: ({ row }) => {
          return row.original.ratings
            ? createStar(parseFloat(row.original.ratings).toFixed(2))
            : createStar(0);
        },
      },
      // {
      //   Header: 'Message',
      //   accessor: 'message',
      //   id: 'message',
      // },
    ],
    [masterData.newStatusList, tableData, dollarOpen]
  );

  const hideModal = () => {
    setShowModal(!showModal);
  };

  const openShiftRelease = async () => {
    const selectedRows = storage.getItem('selectedRows')
      ? storage.getItem('selectedRows')
      : [];
    if (selectCandidate) {
      if (selectedRows.length === 0) {
        Toasts.error('Please Select candidates');
      } else {
        const formatdata = await formatData(
          shiftOrderSelectedData['data'],
          selectCandidate
        );
        setShiftOrderSelectedData({
          ...shiftOrderSelectedData,
          data: formatdata,
        });
        setShowShiftRelase(!showShiftRelase);
      }
    } else {
      const formatdata = await formatData(
        shiftOrderSelectedData['data'],
        selectCandidate
      );
      setShiftOrderSelectedData({
        ...shiftOrderSelectedData,
        data: formatdata,
      });
      setShowShiftRelase(!showShiftRelase);
    }
  };

  // open Shift Encounter Relese Function

  const openShiftAssignJobToCandidateRelese = () => {
    const selectedRows = storage.getItem('selectedRows')
      ? storage.getItem('selectedRows')
      : [];
    if (createJobPage && selectedRows?.length > 1) {
      openShiftAssignJobToCandidateMultipleRelese();
    } else {
      openShiftAssignJobToCandidateSingleRelese();
    }
  };

  const [candidateShiftOverLapPopup, setCandidateShiftOverLapPopup] = useState(false);

  const closeCandidateShiftOverLapPopup = () => {
    setCandidateShiftOverLapPopup(false)
  }

  const openShiftAssignJobToCandidateSingleRelese = async () => {
    // get from data local storage
    const selectedRows = storage.getItem('selectedRows')
      ? storage.getItem('selectedRows')
      : [];
    // get from data for CandidateUniqueId
    const candidateUniqueId = selectedRows.map(
      (item) => item.candidateUniqueId
    );
    if (selectedRows.length === 0) {
      Toasts.error('Please select one candidate user to assign the shift');
    } else if (selectedRows.length > 1) {
      Toasts.error('Please select only one candidate user to assign the shift');
    } else {
      let flag = false;
      selectedRows.map((item) => {
        if (
          item.status !== 'IN Authorized' &&
          item.status !== 'EX Authorized'
        ) {
          Toasts.error(
            ' Please select an authorized candidate to assign a shift'
          );
          flag = true;
          return;
        } else if (item.isCandidateOverlapingShift) {
          // Toasts.error(
          //   'This shift cannot be assigned to the candidate as they have another shift assigned/claimed during this shift time'
          // );
          setCandidateShiftOverLapPopup(true);
          flag = true;
          return;
        } 
        // else if (!item.bankDetailsFlag) {
        //   Toasts.error(
        //     'Please select bank detail filled candidate to assign a shift'
        //   );
        //   flag = true;
        //   return;
        // } 
         else if (!item.payRateSetupFlag) {
          Toasts.error(
            'Please select pay rate filled candidate to assign a shift'
          );
          flag = true;
          return;
        }
      });
      if (!flag) {
        if (candidateUniqueId?.length) {
          if (jobInfo?.isOvertimeAllowed || jobInfo?.shiftType === 2) {
            dispatch(
              AssignJobToCandidate({
                url: `${config.baseUrl}/Employers/assign-job-to-candidate`,
                params: {
                  jobShiftUniqueId: jobInfo?.jobsShiftUniqueId,
                  candidateUniqueId: candidateUniqueId[0],
                },
              })
            ).then((response) => {
              // Response Message Convert a String to Lower case
              const convertToString = response.message.toLowerCase();
              const msg = 'The candidate was previously unclaimed from this shift. The shift cannot be assigned to this candidate';
              // Check the message // "the user has unclaimed this shift earlier. the shift cannot be assigned to this user"
              if (convertToString === msg.toLowerCase()) {
                seterrorModalBox({ popup: true, message: response.message })
              }
              // While Success message Came after Re-direct open Shift
              if (response?.statusCode && parseInt(response?.statusCode) === 200) {
                setTimeout(() => {
                  sessionStorage.removeItem('selectedRows');
                  setSelectCandidate(false)
                  navigate('/openshifts');
                }, 1500);
              }
            });
          } else {
            const overtimeParams = {
              "candidateUniqueId": candidateUniqueId[0],
              "jobsShiftUniqueId": jobInfo?.jobsShiftUniqueId,
              "locationId": locationId,
              "jobsClaimId": 0,
            }
            dispatch(getOvertimeDetails({ url: `${config.baseUrl}/Employers/get-overtime-details`, params: overtimeParams })).then(response => {
              if (response && response?.result === 1) {
                // console.log({totalHoursInMinutes,response:response?.remainingMinutes});
                if (response?.isAllowedToClaim) {
                  dispatch(
                    AssignJobToCandidate({
                      url: `${config.baseUrl}/Employers/assign-job-to-candidate`,
                      params: {
                        jobShiftUniqueId: jobInfo?.jobsShiftUniqueId,
                        candidateUniqueId: candidateUniqueId[0],
                      },
                    })
                  ).then((response) => {
                    // Response Message Convert a String to Lower case
                    const convertToString = response.message.toLowerCase();
                    const msg = 'The candidate was previously unclaimed from this shift. The shift cannot be assigned to this candidate';
                    // Check the message
                    if (convertToString === msg.toLowerCase()) {
                      seterrorModalBox({ popup: true, message: response.message })
                    }
                    // While Success message Came after Re-direct open Shift
                    if (response?.statusCode && parseInt(response?.statusCode) === 200) {
                      setTimeout(() => {
                        sessionStorage.removeItem('selectedRows');
                        setSelectCandidate(false)
                        navigate('/openshifts');
                      }, 1500);
                    }
                  });
                } else {
                  // ValidationPopup
                  setOvertimeValidModal(prev => ({ ...prev, "status": !overtimeValidModal.status, "response": { ...response, candidateUniqueId, jobShiftUniqueId: jobInfo?.jobsShiftUniqueId } }))

                }
              }
              else {
                // toast error
                toast.error(response?.message)
              }
            })
          }
        }
      }
    }
  };

  // Modal Box Closing function
  const errorModalBoxClose = () => {
    seterrorModalBox(false)
  }

  const openShiftAssignJobToCandidateMultipleRelese = async () => {
    // get from data local storage
    const selectedRows = storage.getItem('selectedRows')
      ? storage.getItem('selectedRows')
      : [];
    // get from data for CandidateUniqueId
    const candidateUniqueId = selectedRows.map(
      (item) => item.candidateUniqueId
    );
    // else if (selectedRows.length > 1) {
    //   Toasts.error('Please select only one candidate user to assign the shift');
    // }
    if (selectedRows.length === 0) {
      Toasts.error('Please select one candidate user to assign the shift');
    } else {
      let flag = false;
      let overLapFlag = false;
      let authValidation = false;
      let bankFlag = false;
      let payrateFlag = false;
      selectedRows.map((item, index) => {
        if (
          item.status !== 'IN Authorized' &&
          item.status !== 'EX Authorized'
        ) {
          authValidation = true;
          flag = true;
          return;
        } else if (item.isCandidateOverlapingShift && !overLapFlag && params.candidateTeamId === 0) {
          Toasts.error('Shift Overlaping');
          flag = true;
          overLapFlag = true
          return;
        } 
        //  else if (!item.bankDetailsFlag && !bankFlag) {
        //   Toasts.error(
        //     'Please select bank detail filled candidate to assign a shift'
        //   );
        //   flag = true;
        //   bankFlag = true;
        //   return;
        // } 
        else if (!item.payRateSetupFlag && !payrateFlag) {
          Toasts.error(
            'Please select pay rate filled candidate to assign a shift'
          );
          flag = true;
          payrateFlag = true;
          return;
        }
      });
      if (authValidation) {
        Toasts.error(
          ' Please select an authorized candidate to assign a shift'
        );
        return
      }
      if (!flag) {
        setSchedulingModal(!schedulingModal);
      }
    }
  };
  const saveJobMulitipleCandidate = async () => {
    // get from data local storage
    const selectedRows = storage.getItem('selectedRows')
      ? storage.getItem('selectedRows')
      : [];

    // Filter overlaping candidate 
    const overlapingCandidate = selectedRows.filter(item => item.isCandidateOverlapingShift !== true);

    // get from data for CandidateUniqueId
    const candidateUniqueId = overlapingCandidate.map((item) => {
      return { candidateUniqueId: item.candidateUniqueId, allowOverwrite: true }
    });


    // // After Filter Candidate send a Assign
    // const teamAssignCandidateUniqueId = overlapingCandidate.map((item) => {
    //   return { candidateUniqueId: item.candidateUniqueId, allowOverwrite: true }
    // });

    if (candidateUniqueId?.length) {
      if (jobInfo?.isOvertimeAllowed || jobInfo?.shiftType === 2) {
        const assignParams = {
          jobShiftUniqueId: jobInfo?.jobsShiftUniqueId,
          candidateAssignParams: candidateUniqueId,
        }
        const teamAssignParams = {
          jobShiftUniqueId: jobInfo?.jobsShiftUniqueId,
          candidateAssignParams: candidateUniqueId,
          candidateTeamId: params.candidateTeamId
        }
        // console.log(isAllowedToClaim,assignParams);
        dispatch(
          AssignJobToMultipleCandidate({
            url: `${config.baseUrl}/Employers/assign-job-to-multiple-candidates`,
            params: teamAssignEnableBtn === true ? assignParams : teamAssignParams

          })
        )
          .then((response) => {
            if (response && response?.result === 1) {
              setMultiAssignResponseModal(prev => ({ ...prev, status: true, response: response?.assignJobResultDtos }))
            }
            setSchedulingModal(!schedulingModal);
          });
      } else {
        const overtimeParams = {
          "candidateUniqueId": candidateUniqueId?.map(item => item?.candidateUniqueId),
          "jobsShiftUniqueId": jobInfo?.jobsShiftUniqueId,
          "locationId": locationId,
          "jobsClaimId": 0,
        }
        dispatch(getOvertimeDetails({ url: `${config.baseUrl}/Employers/get-multicandidate-overtime-details`, params: overtimeParams })).then(response => {
          if (response?.length) {
            const isAllowedToClaim = response?.every(candi => candi?.isAllowedToClaim)
            if (isAllowedToClaim) {
              const assignParams = {
                jobShiftUniqueId: jobInfo?.jobsShiftUniqueId,
                candidateAssignParams: candidateUniqueId,
              }
              const teamAssignParams = {
                jobShiftUniqueId: jobInfo?.jobsShiftUniqueId,
                candidateAssignParams: candidateUniqueId,
                candidateTeamId: params.candidateTeamId
              }
              // console.log(isAllowedToClaim,assignParams);
              dispatch(
                AssignJobToMultipleCandidate({
                  url: `${config.baseUrl}/Employers/assign-job-to-multiple-candidates`,
                  params: teamAssignEnableBtn === true ? assignParams : teamAssignParams

                })
              )
                .then((response) => {
                  if (response && response?.result === 1) {
                    setMultiAssignResponseModal(prev => ({ ...prev, status: true, response: response?.assignJobResultDtos }))
                  }
                  setSchedulingModal(!schedulingModal);
                });
            }
            else {
              // ValidationPopup
              setSchedulingModal(!schedulingModal);
              const candiList = response?.map(item => {
                if (item?.isAllowedToClaim) {
                  return { candidateUniqueId: item?.candidateUniqueId, allowOverwrite: true }
                } else {
                  return { candidateUniqueId: item?.candidateUniqueId, allowOverwrite: false  }
                }
              })
              setOvertimeMultiValidModal(prev => ({ ...prev, "status": !overtimeMultiValidModal.status, "response": response, params: { candidateAssignParams: candiList, jobShiftUniqueId: jobInfo?.jobsShiftUniqueId } }))
            }
          }
          else {
            // toast error
            toast.error(response?.message)
          }
        })
      }
    } else {
      if (candidateUniqueId?.length === 0) {
        setSchedulingModal(!schedulingModal);
        toast.error("Shift Overlaping")
      }
    }
  };


  // const saveJobMulitipleCandidate = async () => {
  //   // get from data local storage
  //   const selectedRows = storage.getItem('selectedRows')
  //     ? storage.getItem('selectedRows')
  //     : [];

  //   // get from data for CandidateUniqueId
  //   const candidateUniqueId = selectedRows.map(
  //     (item) => item.candidateUniqueId
  //   );

  //   if (candidateUniqueId?.length) {
  //     dispatch(
  //       AssignJobToMultipleCandidate({
  //         url: `${config.baseUrl}/Employers/assign-job-to-multiple-candidates`,
  //         params: {
  //           jobShiftUniqueId: jobInfo?.jobsShiftUniqueId,
  //           candidateUniqueIds: candidateUniqueId,
  //         },
  //       })
  //     ).then((response) => {
  //       if (response?.statusCode && parseInt(response?.statusCode) === 200) {
  //         setTimeout(() => {
  //           navigate("/openshifts")
  //         }, 1500)
  //       }
  //       setSchedulingModal(!schedulingModal);
  //     });
  //   }
  // };

  const closeShiftRelease = () => {
    setShowShiftRelase(!showShiftRelase);
  };

  const getShiftoderData = (data, type) => {
    setShiftOrderSelectedData({
      ...shiftOrderSelectedData,
      [type]: data,
    });
    setShiftOderValidation({});
  };

  const getSelectCandidate = (target) => {
    const selectedRows = storage.getItem('selectedRows')
    if (selectedRows?.length) {
      setSelectCandidate(target.checked);
    } else {
      Toasts.info('Please Select the Candidates');
      return ''
    }
  };

  const shiftOrderSaveAndValidate = () => {
    if (
      !shiftOrderSelectedData['data']?.['columns']?.['column-2']?.orderIds
        ?.length &&
      !shiftOrderSelectedData['form'].time &&
      !shiftOrderSelectedData['form'].authorizedUser
    ) {
      setShiftOderValidation({
        data: 'Please select a release order or select authorized users checkbox before posting a shift',
      });
    } else if (shiftOrderSelectedData['form'].authorizedUser) {
      setShiftOderValidation({});
      setPostjobDisable(false);
      setShowShiftRelase(!showShiftRelase);
      postJob();
    } else if (
      shiftOrderSelectedData['data']?.['columns']?.['column-2']?.orderIds
        ?.length
    ) {
      if (!shiftOrderSelectedData['form'].time) {
        setShiftOderValidation({
          time: 'Please select time',
        });
      } else {
        setPostjobDisable(false);
        setShiftOderValidation({});
        setShowShiftRelase(!showShiftRelase);
        postJob();
      }
    } else if (shiftOrderSelectedData['form'].time) {
      if (
        !shiftOrderSelectedData['data']?.['columns']?.['column-2']?.orderIds
          ?.length
      ) {
        setShiftOderValidation({
          data: 'Please select a release order or select authorized users checkbox before posting a shift',
        });
      } else {
        setPostjobDisable(false);
        setShiftOderValidation({});
        setShowShiftRelase(!showShiftRelase);
        postJob();
      }
    } else {
      setPostjobDisable(false);
      setShiftOderValidation({});
      setShowShiftRelase(!showShiftRelase);
      postJob();
    }
  };

  const hidePostModal = () => {
    setRepostModal(!showRepostModal);
  };

  const postJobAgainAuthorizedUser = (body) => {
    // Number of Shift More then or less then one Call the API
    if (noOfShiftNeeded < 1) {
      // Single Job Post
      dispatch(
        sendPostJob({
          url: `${config.baseUrl}/Employers/jobs-matching-candidates`,
          params: body,
        })
      ).then((response) => {
        if (response?.result > 0) {
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false)
          navigate('/openshifts');
          Toasts.success(response?.message);
        } else {
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false)
          navigate('/openshifts');
          Toasts.error(response?.message);
        }
      });
    } else {
      // Multiple Jobs Posting
      dispatch(
        sendPostMultipleJobs({
          url: `${config.baseUrl}/Employers/multiplejobs-posting`,
          params: {
            ...body,
            jobCount: parseInt(noOfShiftNeeded),
            jobsShiftId: null
          },
        })
      ).then((response) => {
        if (response?.result > 0) {
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false)
          navigate('/openshifts');
          Toasts.success(response?.message);
        } else {
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false)
          navigate('/openshifts');
          Toasts.error(response?.message);
        }
      });
    }
  }
  const savePostAgain = () => {
    const body = createPostPayload(postjobData);
    const selectedRows = storage.getItem('selectedRows')
      ? storage.getItem('selectedRows')
      : [];
    let flag = false;
    selectedRows.map((item) => {
      if (
        item.status !== 'IN Authorized' &&
        item.status !== 'EX Authorized'
      ) {
        Toasts.error(
          ' Please select an authorized candidate to post job'
        );
        flag = true;
        return;
      }
      else if (item?.isCandidateOverlapingShift  || !item.payRateSetupFlag) {
        // else if (item?.isCandidateOverlapingShift || !item.bankDetailsFlag || !item.payRateSetupFlag) {
        Toasts.error(
          'No candidates available to post the shift'
        );
        flag = true;
        return;
      }
      // else if (!item.bankDetailsFlag) {
      //   Toasts.error(
      //     'Please select bank detail filled candidate to post job'
      //   );
      //   flag = true;
      //   return;
      // } else if (!item.payRateSetupFlag) {
      //   Toasts.error(
      //     'Please select pay rate filled candidate to post job'
      //   );
      //   flag = true;
      //   return;
      // }
    });
    if (postjobData && !flag) {
      if (jobInfo?.isOvertimeAllowed) {
        postJobAgainAuthorizedUser(body);
      }
      else {
        const overtimeParams = {
          candidateUniqueId: body?.candidatesInfo?.map((item) => item?.candidateUniqueId),
          jobsShiftUniqueId: jobInfo?.jobsShiftUniqueId,
          locationId: locationId,
          jobsClaimId: 0,
        };
        dispatch(getOvertimeDetails({ url: `${config.baseUrl}/Employers/get-multicandidate-overtime-details`, params: overtimeParams, }))
          .then((response) => {
            if (response?.length) {
              const isAllowedToClaim = response?.every((candi) => candi?.isAllowedToClaim);
              console.log({ isAllowedToClaim, response, body });
              if (isAllowedToClaim) {
                postJobAgainAuthorizedUser(body);
              } else {
                // let newCandidatesInfo = [];
                // response?.forEach(item => {
                //   if(item?.isAllowedToClaim){
                //     body?.candidatesInfo?.forEach(candiInfo => {
                //       if(candiInfo?.candidateUniqueId === item?.candidateUniqueId){
                //         newCandidatesInfo.push({...candiInfo, allowOverwrite: true })
                //       }
                //     })
                //   } else {
                //     body?.candidatesInfo?.forEach(candiInfo => {
                //       if(candiInfo?.candidateUniqueId === item?.candidateUniqueId){
                //         newCandidatesInfo.push({...candiInfo, allowOverwrite: false })
                //       }
                //     })
                //   }
                // })
                // const copyBody = {...body}
                // const newCandidatesInfo = copyBody?.candidatesInfo?.map((candiInfo,index) => {
                //   if(response?.[index]?.isAllowedToClaim){
                //     return {...candiInfo,allowOverwrite:true}
                //   } else {
                //        return {...candiInfo,allowOverwrite:false}
                //   }
                // })
                const newCandidatesInfo = []
                body?.candidatesInfo?.forEach((candiInfo, index) => {
                  console.log({ inde: response?.[index]?.isAllowedToClaim });
                  // if(response&& response[index]?.isAllowedToClaim){
                  //   return {...candiInfo,allowOverwrite:true}
                  // } else {
                  //      return {...candiInfo,allowOverwrite:false}
                  // }
                  response?.forEach(item => {
                    if (candiInfo?.candidateUniqueId === item?.candidateUniqueId) {
                      if (item?.isAllowedToClaim) {
                        newCandidatesInfo.push({ ...candiInfo, allowOverwrite: true })
                      } else {
                        newCandidatesInfo.push({ ...candiInfo, allowOverwrite:false })
                      }
                    }
                  })
                })
                setPostJobResponseModal(prev => ({ ...prev, type: "repost", "status": !postJobResponseModal.status, "response": response, params: { ...body, candidatesInfo: newCandidatesInfo } }))
                setRepostModal(!showRepostModal);
              }
            }
          })
      }
    }
  };
  // console.log({postJobResponseModal});
  const hideStatusWaringModal = () => {
    setShowStatusWaring(!showStatusWaring);
  };

  const hideSchedulingModal = () => {
    setSchedulingModal(!schedulingModal);
  };

  // Group SMS Modal popup
  const groupSMSModalPopup = (data) => {
    if (data.length === 0) {
      Toasts.warning("Please Select Candidates");
    } else {
      setSmsModalInd(true);
      setGroupSMSSaveFlag(true);
      setGroupSMSData(data);
    }
  };

  // Save Method SMS modal popup
  const saveGroupSMSModal = async () => {
    const candidateUniqueId = groupSMSData?.map((item) => item?.candidateUniqueId)
    const requestBody = {
      candidateUniqueId,
      messageBody: smsModalGetData.sms,
    };
    await dispatch(
      sendSMS({
        url: `${config.baseUrl}/Messaging/send-group-sms-to-candidate`,
        params: requestBody,
      }),
    ).then(() => {
      const newparams = {
        ...params,
        jobShiftUniqueId: matchingJobid,
        jobsClaimId: jobsClaimId ? jobsClaimId : 0,
      };
      dispatch(
        getMatchingCandidateDetail({
          url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
          params: newparams,
        })
      )
      sessionStorage.removeItem('selectedRows');
    });
    setSmsModalGetData('')
    setSmsModalInd(false);
    setGroupSMSSaveFlag(false);
  };


  // SMS Show modal box
  const showSmsModal = async (data) => {
    setGroupSMSSaveFlag(false);
    setCandidateName(data?.name);
    if (smsModalInd) {
      setSmsModalList([]);
    } else {
      if (!!login?.verifiedPhoneNumber) {
        const params = {
          candidateUniqueId: data?.candidateUniqueId,
          employerMobileNumber: login.verifiedPhoneNumber,
          candidateMobileNumber: `${login.countryPhoneCode}${(data.phone).replace(/-/g, '')}`
        }
        const smsDetailsResult = await dispatch(
          getSMSDetails({
            url: `${config.baseUrl}/Messaging/get-sms-messages`, params
          }),
        );
        setSmsModalList(smsDetailsResult);
      } else {
        toast.error("SMS faciality not mapped to this employer.")
        return
      }

    }
    getSmsModalData("sms", "");
    setSmsModalData(data);
    setSmsModalInd((preVal) => !preVal);
  };

  // SMS modal box data
  const getSmsModalData = (index, value) => {
    setSmsModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // SMS save modal box
  const saveSmsModal = async () => {
    const requestBody = {
      candidateUniqueId: smsModalData.candidateUniqueId,
      messageBody: smsModalGetData.sms,
    };
    await dispatch(
      sendSMS({
        url: `${config.baseUrl}/Messaging/send-sms-to-candidate`,
        params: requestBody,
      }),
    );
    showSmsModal();
  };

  // Group Email Modal popup
  const groupEmailModalPopup = (data) => {
    if (data.length === 0) {
      Toasts.warning("Please Select Candidates");
    } else {
      setEmailModalInd(true);
      setGroupEmailSaveFlag(true);
      setGroupEmailData(data);
    }
  };

  // Save Method Email modal popup
  const saveGroupEmailModal = async (sessionUniqueId) => {
    const description = window.emailSummaryNoteValue();
    const candidateUniqueId = groupEmailData?.map((item) => item?.candidateUniqueId)
    if (emailModalGetData.subject && description) {
      const requestBody = {
        candidateUniqueId,
        emailSubject: emailModalGetData.subject,
        messageBody: description,
        sessionId: sessionUniqueId,
        employerUniqueId: login?.employerUniqueId,
      };
      await dispatch(
        sendEmail({
          url: `${config.baseUrl}/Messaging/send-group-email-to-candidate`,
          params: requestBody,
        }),
      ).then(() => {
        const newparams = {
          ...params,
          jobShiftUniqueId: matchingJobid,
          jobsClaimId: jobsClaimId ? jobsClaimId : 0,
        };
        dispatch(
          getMatchingCandidateDetail({
            url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
            params: newparams,
          })
        )
        sessionStorage.removeItem('selectedRows');
      });
      setEmailModalInd(false);
      setGroupEmailSaveFlag(false);
    } else {
      toast.error('Subject field is required')
    }
  };

  // Email Modal 
  const showEmailModal = async (data) => {
    getEmailModalData("subject", "");
    if (emailModalInd) {
      setEmailModalList([]);
    } else {
      const emailDetailsResult = await dispatch(
        getEmailDetails({
          url: `${config.baseUrl}/Messaging/get-email-messages/${data.candidateUniqueId}`,
        }),
      );
      if (Array.isArray(emailDetailsResult) && emailDetailsResult?.length) setEmailModalList(emailDetailsResult);
    }
    setEmailModalData((preVal) => [data]);
    setEmailModalInd((preVal) => !preVal);
  };

  // Email modal data
  const getEmailModalData = (index, value) => {
    setEmailModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // Email save function
  const saveEmailModal = async (sessionUniqueId) => {
    const description = window.emailSummaryNoteValue();
    if (emailModalGetData.subject && description) {
      const requestBody = {
        candidateUniqueId: valueJoinWithComma(
          emailModalData,
          "candidateUniqueId",
        ),
        emailSubject: emailModalGetData.subject,
        messageBody: description,
        sessionId: sessionUniqueId,
        employerUniqueId: login?.employerUniqueId,
      };
      await dispatch(
        sendEmail({
          url: `${config.baseUrl}/Messaging/send-email-to-candidate`,
          params: requestBody,
        }),
      );
      showEmailModal();
    } else {
      toast.error('Subject field is required')
    }
  };

  // Showing value
  const valueJoinWithComma = (inputValue, key) => {
    let returnValue = "";
    if (!inputValue) return returnValue;
    if (!key) {
      returnValue = inputValue.join(",");
    } else {
      returnValue = inputValue.map((e) => e[key]).join(",");
    }
    return returnValue;
  };

  // Send ALL Email 
  const sendAllEmail = () => {
    dispatch(
      sendAllEmailbtn(`${config.baseMailUrl}/Messaging/sendallemails`)
    ).then((res) => {
      if (res.status === 200) {
        toast.success('Email sent successfully!')
      } else {
        toast.error('Email Not sent!')
      }
    })
    showEmailModal();
  };

  // Email Read
  const sendReadEmail = () => {
    if (config.baseUrl) {
      dispatch(sendAllEmailbtn(`${config.baseMailUrl}/Email/email-read-by-Graph`))
        .then((res) => {
          if (res.status === 200) {
            toast.success('Employer Email details updated successfully')
          } else {
            toast.error('Employer Email details are not updated')
          }
        })
    };
    showEmailModal();
  };

  // Send ALL SMS
  const sendAllSms = () => {
    dispatch(
      sendAllSmsbtn('https://development.overturexl.com/DevMessagingApi/api/Messaging/sendSMS')
    );
    showSmsModal();
  };


  // Call Modal 
  const showCallModal = async (data) => {
    if (callModalInd) {
      setCallModalList([]);
    } else {
      const params = {
        phoneNumber: `${login.countryPhoneCode}${(data.phone).replace(/-/g, '')}`
      }
      dispatch(getCallHistory(config.baseUrl, params)).then((callDetailsResult) => {
        if (Array.isArray(callDetailsResult) && callDetailsResult?.length) setCallModalList(callDetailsResult);
      })
      setCallParams({
        phoneNumber: data.phone,
        candidateUniqueId: data.candidateUniqueId,
        jobsClaimId: jobsClaimId ? jobsClaimId : 0,
        jobsShiftUniqueId: jobInfo?.jobsShiftUniqueId
      });
    }
    setCallModalData((preVal) => [data]);
    setCallModalInd((preVal) => !preVal);
  };
  // Once hangUP the Call that time Call History API Updated
  const getCallHistoryList = (phone) => {
    const params = {
      phoneNumber: `${(phone).replace(/-/g, '')}`
    }
    dispatch(getCallHistory(config.baseUrl, params)).then((callDetailsResult) => {
      if (Array.isArray(callDetailsResult) && callDetailsResult?.length) setCallModalList(callDetailsResult);
    })
  }
  const saveOverTimeModal = () => {
    const params = {
      jobShiftUniqueId: overtimeValidModal.response?.jobsShiftUniqueId ? overtimeValidModal.response?.jobsShiftUniqueId : jobInfo?.jobsShiftUniqueId,
      candidateUniqueId: overtimeValidModal.response?.candidateUniqueId[0],
      allowOverwrite: true
    }
    dispatch(
      AssignJobToCandidate({
        url: `${config.baseUrl}/Employers/assign-job-to-candidate`,
        params
      })
    ).then((response) => {
      // Response Message Convert a String to Lower case
      const convertToString = response.message.toLowerCase();
      const msg = 'The candidate was previously unclaimed from this shift. The shift cannot be assigned to this candidate';
      // Check the message // "the user has unclaimed this shift earlier. the shift cannot be assigned to this user"
      if (convertToString === msg.toLowerCase()) {
        seterrorModalBox({ popup: true, message: response.message })
      }
      // While Success message Came after Re-direct open Shift
      if (response?.statusCode && parseInt(response?.statusCode) === 200) {
        setTimeout(() => {
          sessionStorage.removeItem('selectedRows');
          setSelectCandidate(false)
          navigate('/openshifts');
        }, 1500);
      }
    });
    setOvertimeValidModal(initialSinglOvertime)
  }

  const closeOvertimeModal = () => {
    setOvertimeValidModal(initialSinglOvertime)
  }


  const saveOvertimeMultiModal = () => {
    if (overtimeMultiValidModal.params?.candidateAssignParams?.length) {
      const params = {
        jobShiftUniqueId: overtimeMultiValidModal.params?.jobsShiftUniqueId ? overtimeMultiValidModal.params?.jobsShiftUniqueId : jobInfo?.jobsShiftUniqueId,
        candidateAssignParams: overtimeMultiValidModal.params?.candidateAssignParams,
      }
      dispatch(
        AssignJobToMultipleCandidate({
          url: `${config.baseUrl}/Employers/assign-job-to-multiple-candidates`,
          params,
        })
      ).then((response) => {
        if (response?.result === 1) {
          // setTimeout(() => {
          //   navigate("/openshifts")
          // }, 1500)
          setMultiAssignResponseModal(prev => ({ ...prev, status: true, response: response?.assignJobResultDtos }))
        }
        // setSchedulingModal(!schedulingModal);
      });
      setOvertimeMultiValidModal(initialMultiOvertime)
    }
    else {
      Toasts.error(`Please Select candidates`);
    }
  }
  const closeOvertimeMultiModal = () => {
    setOvertimeMultiValidModal(initialMultiOvertime)
  }
  const overtimeChangeHandler = ({ radioName, candiID }) => {
    if (radioName === "NO") {
      const filterCandiList = overtimeMultiValidModal?.params?.candidateAssignParams?.map(item => {
        if (item?.candidateUniqueId === candiID) {
          return { ...item, allowOverwrite: false }
        } else {
          return item
        }
      })
      setOvertimeMultiValidModal(prev => ({ ...prev, params: { ...overtimeMultiValidModal?.params, candidateAssignParams: filterCandiList } }));
    } else if (radioName === "YES") {
      const filterCandiList = overtimeMultiValidModal?.params?.candidateAssignParams?.map(item => {
        if (item?.candidateUniqueId === candiID) {
          return { ...item, allowOverwrite: true }
        } else {
          return item
        }
      })
      setOvertimeMultiValidModal(prev => ({ ...prev, params: { ...overtimeMultiValidModal?.params, candidateAssignParams: filterCandiList } }));
    }
  }
  const postOvertimeChangeHandler = ({ radioName, candiID }) => {
    if (radioName === "NO") {
      const filterCandiList = postJobResponseModal?.params?.candidatesInfo?.map(item => {
        if (item?.candidateUniqueId === candiID) {
          return { ...item, allowOverwrite: false }
        } else {
          return item
        }
      })
      setPostJobResponseModal(prev => ({ ...prev, params: { ...postJobResponseModal?.params, candidatesInfo: filterCandiList } }));
    } else if (radioName === "YES") {
      const filterCandiList = postJobResponseModal?.params?.candidatesInfo?.map(item => {
        if (item?.candidateUniqueId === candiID) {
          return { ...item, allowOverwrite: true }
        } else {
          return item
        }
      })
      setPostJobResponseModal(prev => ({ ...prev, params: { ...postJobResponseModal?.params, candidatesInfo: filterCandiList } }));
    }
  }

  const saveOvertimePostJob = () => {
    if (postJobResponseModal.params?.candidatesInfo?.length) {
      if (postJobResponseModal?.type === "post") {
        postJobAuthorizedUsers(postJobResponseModal.params)
      } else if (postJobResponseModal?.type === "repost") {
        postJobAgainAuthorizedUser(postJobResponseModal.params);
      }
      setPostJobResponseModal(initialPostOvertime)
    } else {
      Toasts.error(`Please Select candidates`);
    }
  }

  const closeOvertimePostJob = () => {
    setPostJobResponseModal(initialPostOvertime)
  }

  const navigateToOpenshift = () => {
    navigate("/openshifts")
  }
  const handlePageChange = (pageNumber) => {
    setForm({
      ...params,
      page: pageNumber,
      jobsClaimId: jobsClaimId ? jobsClaimId : 0,
      jobShiftUniqueId: matchingJobid,
    });
    const newparams = {
      ...form,
      page: pageNumber,
      jobsClaimId: jobsClaimId ? jobsClaimId : 0,
      jobShiftUniqueId: matchingJobid,
    };
    console.log(newparams);
    dispatch(
      getMatchingCandidateDetail({
        url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
        params: newparams,
      })
    );
  };

  const handlePageSize = (pageSize) => {
    setForm({
      ...params,
      pageSize: pageSize,
      page: 1,
      jobsClaimId: jobsClaimId ? jobsClaimId : 0,
      jobShiftUniqueId: matchingJobid,
    });
    const newparams = {
      ...form,
      pageSize: pageSize,
      page: 1,
      jobShiftUniqueId: matchingJobid,
      jobsClaimId: jobsClaimId ? jobsClaimId : 0,
    };
    dispatch(
      getMatchingCandidateDetail({
        url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
        params: newparams,
      })
    );
  };
  const depsUnits = useSelector((store) => store.matchingCandidateInfo.depsUnits);
  const closeDepartmentModal = () => {
    // if (!isDepartmentsExist && depsUnits?.length === 0) {
    //   setDepsError("Please select department");
    //   return
    // } else if (!isDepartmentsExist && depsUnits?.length > 0) {
    //   setDepsError("Please save selected departments");
    //   return
    // } else {
    //   setDepsError("")
    // }
    // if(depsUnits?.length === 0 && depsUnitsMaster?.length > 0 ){
    //   setDepsError("Please select department");
    //   return
    // } 
    // if(!(depsUnits?.length > 0)){
    //   updateStatusOfEmployer(false);
    // } else {
    //   updateStatusOfEmployer(true);
    // }
    if(!isDepartmentsExist){
      updateStatusOfEmployer(false,true);
      // Toasts.error('The candidate status is not updated. Please select a department.')
    } else {
      updateStatusOfEmployer(false);
    }
    dispatch(setValue({ name: "depsUnits", value: [] }))
    setShowDepartmentModal((prev) => ({ ...prev, status: false, result: {} }));
  }
  const saveDepartmentModal = () => {
    if (depsUnits && depsUnits?.length === 0) {
      setDepsError("Please select  department");
      return
    } else {
      setDepsError("")
    }
    let unMappedStatus = false;
    const depsIdList = depsUnits?.length ? depsUnits?.map((depUnit) => depUnit?.id) : []
    initialDepartmentList?.forEach(initialDepsId => {
      if (depsIdList?.indexOf(initialDepsId) < 0) {
        unMappedStatus = true
      }
    })
    const mappedParams = {
      locationId: locationId ? locationId : "",
      candidateUniqueId: showDepartmentModal?.result?.candidateUniqueId
        ? showDepartmentModal?.result?.candidateUniqueId : "",
      candidateDepartmentId: depsIdList,
      employerCandidateStatusID: +childarg?.id,
      isUnmapped: unMappedStatus
    };
     updateEmpDepStatus({mappedParams,isDepartmentsExist})
    // dispatch(mapDepartmentsToCandidate({ baseUrl: config?.baseUrl, params: updateParams })).then(response => {
    //   if(!isDepartmentsExist){
    //     updateStatusOfEmployer(response,!response);
    //     // Toasts.error('The candidate status is not updated. Please select a department.')
    //   } else {
    //     updateStatusOfEmployer(response);
    //   }
      // if(!response){
      // Toasts.error('The candidate status is not updated. Please select a department.')
      // }
      // updateStatusOfEmployer(response);
      // if (response) {

        // const searchDepartments = jobInfo?.listJobsDepartments?.map(item => item?.name);
        // const copyData = [...tableData]
        // const updateData = copyData?.map((candi) => {
        //   if (candi?.candidateUniqueId === showDepartmentModal?.result?.candidateUniqueId) {
        //     return {
        //       ...candi,
        //       departmentsList:depsUnits?.length ? depsUnits?.map(item => ({name:item?.name,isExists:searchDepartments?.indexOf(item?.name) >= 0 ? 1:0})) :[],
        //     };
        //   } else {
        //     return candi;
        //   }
        // });
        // setTableData(updateData)
        // const newparams = {
        //   ...params,
        //   jobShiftUniqueId: matchingJobid,
        //   jobsClaimId: jobsClaimId ? jobsClaimId : 0,
        // };
        // dispatch(
        //   getMatchingCandidateDetail({
        //     url: `${config.baseUrl}/Employers/matching-candidates-for-new-job`,
        //     params: newparams,
        //   })
        // );
      // }
    // })
    dispatch(setValue({ name: "depsUnits", value: [] }))
    setShowDepartmentModal((prev) => ({ ...prev, status: false, result: {} }));
  };

  // Shift Length Conversion
  const shiftHoursCalc = (time) => {
    let shiftHours = "";
    const hours = Math.floor(parseInt(time) / 60);
    const minutes = parseInt(time) % 60;
    if (hours) {
      shiftHours += `${hours} ${parseInt(hours) === 1 ? "hr " : "hrs "}`;
    }
    if (minutes) {
      shiftHours += `${minutes} mins`;
    }
    return shiftHours;
  };
  const closeErrorModalHandler  = () => setShowErrorModal(false);
  return (
    <div className="page main-margin">
      {loadingFlag > 0 && <Spinner />}
      <Header />
      <Sidebar />
      <EmailModal
        showModal={emailModalInd}
        handleClose={showEmailModal}
        data={groupEmailSaveFlag ? groupEmailData : emailModalData}
        handleSave={groupEmailSaveFlag ? saveGroupEmailModal : saveEmailModal}
        handleForm={getEmailModalData}
        formData={emailModalGetData}
        listData={emailModalList}
        sendAllEmail={sendAllEmail}
        sendReadEmail={sendReadEmail}
      />
      <SMSModal
        showModal={smsModalInd}
        handleClose={showSmsModal}
        data={groupSMSSaveFlag ? groupSMSData : smsModalData}
        handleSave={groupSMSSaveFlag ? saveGroupSMSModal : saveSmsModal}
        formData={smsModalGetData}
        handleForm={getSmsModalData}
        listData={smsModalList}
        sendAllSms={sendAllSms}
        groupSMSSaveFlag={groupSMSSaveFlag}
        candidateName={candidateName}
      />
      <CallModal
        showModal={callModalInd}
        handleClose={showCallModal}
        listData={callModalList}
        phoneNumber={callParams.phoneNumber}
        candidateUniqueId={callParams.candidateUniqueId}
        getCallHistoryList={getCallHistoryList}
        jobsClaimId={callParams.jobsClaimId}
        jobsShiftUniqueId={callParams.jobsShiftUniqueId}
      />
      {/* This Modal Box only Showing a Error Message for Pariticular error */}
      {
        errorModalBox.popup &&
        <Modal
          showHide={errorModalBoxClose}
          label={"Alert"}
          size={"lg"}
          center={true}
          onlyClose={true}
        >
          <div className="toast-body">
            <h4 className='d-flex gap-3' style={{ textDecoration: "none" }}>
              <i class="fa fa-times-circle red-icon" style={{ fontSize: "25px" }} aria-hidden="true"></i>
              {errorModalBox.message}
            </h4>
          </div>
        </Modal>
      }
      {candidateShiftOverLapPopup &&
        <Modal
          showHide={closeCandidateShiftOverLapPopup}
          label={"Alert"}
          size={"lg"}
          onlyClose={true}
          center={true}
          closeButtonName={'Ok'}
        >
          <div className="toast-body fw-bold">
            <h4 className='d-flex gap-3' style={{ textDecoration: "none" }}>
              <i class="fa fa-times-circle red-icon" style={{ fontSize: "25px" }} aria-hidden="true"></i>
              This shift cannot be assigned to the candidate as he/she has another shift assigned/claimed during this shift time
            </h4>
          </div>
        </Modal>
      }
      {showErrorModal && <ErrorMsgModal errorMsg={"The candidate status is not updated. Please select a department to authorize."} closeHandler={closeErrorModalHandler}/>}
      {/* deparmentModal */}
      {
        showDepartmentModal?.status &&
        <Modal
          showHide={closeDepartmentModal}
          label={"Departments"}
          size={"lg"}
          center={true}
          saveFunction={saveDepartmentModal}
        >
          <DepsUnits value={showDepartmentModal} depsUnitsRef={depsUnitsRef} depsError={depsError} />
        </Modal>
      }

      <div className="page-main">
        <div className="main-content app-content mt-0 main-background">
          <div className="side-app">
            <div className="main-container container-fluid">
              <div className="page-header">
                <h1 className="page-title">Matching Candidate</h1>
                <div>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="javascript:void(0)">Dashboard</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Locations
                    </li>
                  </ol>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    {schedulingModal && (
                      <Modal
                        showHide={hideSchedulingModal}
                        label={'Scheduling - Assign'}
                        size={'lg'}
                        saveFunction={saveJobMulitipleCandidate}
                      >
                        <h3>
                          Confirm Shift Assignment?
                        </h3>
                        <div className="row">
                          <div className="col-12">
                            <table className='table table-bordered'>
                              <thead className=''>
                                <tr>
                                  <th className="text-center" style={{
                                    // width: "70px"
                                  }}>#</th>
                                  <th>Candidate Name</th>
                                  <th>Message</th>
                                </tr>
                              </thead>
                              <tbody>
                                {storage.getItem('selectedRows') &&
                                  storage.getItem('selectedRows').length &&
                                  storage
                                    .getItem('selectedRows')
                                    .map((element, index) => {
                                      return (
                                        <tr>
                                          <td className='bg-white text-center' style={{
                                            // width: "70px"
                                          }}>{index + 1}</td>
                                          <td className={`bg-white ${element.isCandidateOverlapingShift === true ? 'text-danger' : ''}`}>
                                            {element.firstName}{' '}
                                            {element.lastName}
                                          </td>
                                          <td className='bg-white'>
                                            {
                                              element.isCandidateOverlapingShift === true ? "Shift Overlap, the shift cannot be assigned to the user." : ""
                                            }
                                          </td>
                                        </tr>
                                      );
                                    })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Modal>
                    )}
                    {multiAssignResponseModal?.status && multiAssignResponseModal?.response?.length && (
                      <Modal
                        showHide={navigateToOpenshift}
                        label={'Multiple Assign'}
                        size={'lg'}
                        closeButtonName={"OK"}
                        onlyClose={true}
                      // saveFunction={navigateToOpenshift}
                      >
                        <div className="row">
                          <div className="col-12">
                            <table className='table table-bordered'>
                              <thead className=''>
                                <tr>
                                  <th className="text-center">#</th>
                                  <th>Candidate Name</th>
                                  <th>Status</th>
                                  <th>Message</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  multiAssignResponseModal?.response?.map((item, index) => (
                                    <Fragment key={index}>
                                      <tr>
                                        <td className='bg-white text-center' style={{
                                          width: "100px"
                                        }}>{index + 1}</td>
                                        <td className='bg-white'>
                                          {item?.candidateName}
                                        </td>
                                        <td className='bg-white'>
                                          {item?.isAssigned ? "Assigned" : "Not Assigned"}
                                        </td>
                                        <td className='bg-white'>
                                          {item?.isAssigned ? "" : item?.message}
                                        </td>
                                      </tr>
                                    </Fragment>
                                  ))
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Modal>
                    )}
                    {overtimeMultiValidModal.status &&
                      overtimeMultiValidModal.response?.length && (
                        <Modal
                          saveFunction={saveOvertimeMultiModal}
                          showHide={closeOvertimeMultiModal}
                          label={"Alert"}
                          size={"lg"}
                          center={true}
                        >
                          {overtimeMultiValidModal.response?.map((candi, index) => (
                            <div style={{ marginBottom: "1rem" }} key={index}>
                              {!candi?.isAllowedToClaim && (
                                <>
                                  <div className="d-flex justify-content-between ">
                                    <p className="fw-bold">{candi?.candidateName}</p>
                                    <OvertimeRadio
                                      candiList={overtimeMultiValidModal?.params?.candidateAssignParams}
                                      candiDetails={candi}
                                      changeHandler={overtimeChangeHandler}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      rowGap: "0.75rem",
                                    }}
                                  >
                                    {candi?.shiftOvertimeList?.map((overtimeList, index) => (
                                      <ul style={{ listStyleType: "circle", paddingLeft: "1rem" }}
                                        key={index}
                                      >
                                        {overtimeList?.shiftWeeklyOvertimeList?.some(item => item?.remainingMinutes < 0) && <p className='fw-bold'>
                                          {overtimeList?.locationName}
                                        </p>}
                                        {/* <p className='fw-bold'>{overtimeList?.locationName}</p> */}
                                        {
                                          overtimeList?.shiftWeeklyOvertimeList?.map(shiftWeek => (
                                            <>
                                              {shiftWeek?.remainingMinutes < 0 && (
                                                <>
                                                  <li>
                                                  {`${candi?.candidateName} (Allowed straight time work hours: ${shiftWeek?.candidateOverLimtHours}) `}
                                                          has used{" "}
                                                          {getHoursandMinutes(shiftWeek?.workedStrightHours) ?? ""}
                                                          {" "}
                                                           of straight time and{" "}
                                                          {
                                                          getHoursandMinutes( shiftWeek?.workedShiftOverTimeHours) ?? ""
                                                          }
                                                          {" "}
                                                           of overtime from{" "}
                                                          {shiftWeek?.weekStartDate} to{" "}
                                                          {shiftWeek?.weekEndDate}. This shift
                                                          will put{" "}
                                                          {getHoursandMinutes(shiftWeek?.currentStrightHours) ?? ""}{" "}
                                                           of straight time and{" "}
                                                          {
                                                            getHoursandMinutes(shiftWeek?.currentShiftOverTimeHours) ?? ""
                                                          }{" "}
                                                           of overtime.
                                                  </li>
                                                </>
                                              )}
                                            </>
                                          ))
                                        }

                                      </ul>
                                    )
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          ))}
                        </Modal>
                      )}
                    {postJobResponseModal.status &&
                      postJobResponseModal.response?.length && (
                        <Modal
                          saveFunction={saveOvertimePostJob}
                          showHide={closeOvertimePostJob}
                          label={"Alert"}
                          size={"lg"}
                          center={true}
                        >
                          {postJobResponseModal.response?.map((candi, index) => (
                            <div style={{ marginBottom: "1rem" }} key={index}>
                              {!candi?.isAllowedToClaim && (
                                <>
                                  <div className="d-flex justify-content-between ">
                                    <p className="fw-bold">{candi?.candidateName}</p>
                                    <OvertimeRadio
                                      candiList={postJobResponseModal?.params?.candidatesInfo}
                                      candiDetails={candi}
                                      changeHandler={postOvertimeChangeHandler}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      rowGap: "0.75rem",
                                    }}
                                  >
                                    {candi?.shiftOvertimeList?.map((overtimeList, index) => (
                                      <ul style={{ listStyleType: "circle", paddingLeft: "1rem" }}
                                        key={index}
                                      >
                                        {overtimeList?.shiftWeeklyOvertimeList?.some(item => item?.remainingMinutes < 0) && <p className='fw-bold'>
                                          {overtimeList?.locationName}
                                        </p>}
                                        {/* <p className='fw-bold'>{overtimeList?.locationName}</p> */}
                                        {
                                          overtimeList?.shiftWeeklyOvertimeList?.map(shiftWeek => (
                                            <>
                                              {shiftWeek?.remainingMinutes < 0 && (
                                                <>
                                                  <li>
                                                    
                                          {/* {`${overtimeValidModal.response?.candidateName} `}
                                          has used
                                          {shiftWeek?.candidateOverLimtHours
                                            ? ` ${shiftWeek?.candidateOverLimtHours}hrs `
                                            : " 40hrs "}
                                          of allowed shift time from {shiftWeek?.weekStartDate} to {shiftWeek?.weekEndDate}. */}
                                                    {/* {`${candi?.candidateName} `}
                                                    has used
                                                    {shiftWeek?.candidateOverLimtHours
                                                      ? ` ${shiftWeek?.candidateOverLimtHours}hrs `
                                                      : " 40hrs "}
                                                    of allowed shift time from{" "}
                                                    {shiftWeek?.weekStartDate} to{" "}
                                                    {shiftWeek?.weekEndDate}. */}
                                                     {`${candi?.candidateName} (Allowed straight time work hours: ${shiftWeek?.candidateOverLimtHours}) `}
                                                          has used{" "}
                                                          {getHoursandMinutes(shiftWeek?.workedStrightHours) ?? ""}
                                                          {" "}
                                                           of straight time and{" "}
                                                          {
                                                          getHoursandMinutes( shiftWeek?.workedShiftOverTimeHours) ?? ""
                                                          }
                                                          {" "}
                                                           of overtime from{" "}
                                                          {shiftWeek?.weekStartDate} to{" "}
                                                          {shiftWeek?.weekEndDate}. This shift
                                                          will put{" "}
                                                          {getHoursandMinutes(shiftWeek?.currentStrightHours) ?? ""}{" "}
                                                           of straight time and{" "}
                                                          {
                                                            getHoursandMinutes(shiftWeek?.currentShiftOverTimeHours) ?? ""
                                                          }{" "}
                                                           of overtime.
                                                  </li>
                                                </>
                                              )}
                                            </>
                                          ))
                                        }
                                      </ul>
                                    )
                                    )}
                                  </div>
                                </>
                              )}
                            </div>
                          ))}
                        </Modal>
                      )}
                    {showModal && (
                      <Modal
                        showHide={hideModal}
                        label={'Alert'}
                        size={'md'}
                        center={true}
                        onlyClose={true}
                      >
                        <span className="fw-bold">
                          This shift is already claimed and cannot be posted
                          again !
                        </span>
                      </Modal>
                    )}
                    {(overtimeValidModal.status && overtimeValidModal.response?.shiftOvertimeList?.length) && (
                      <Modal
                        saveFunction={saveOverTimeModal}
                        showHide={closeOvertimeModal}
                        label={'Alert'}
                        size={'md'}
                        center={true}
                        closeButtonName="NO"
                        buttonName="YES"
                      >
                        <div style={{ display: "flex", flexDirection: "column", rowGap: "0.75rem" }}>
                          {overtimeValidModal.response?.shiftOvertimeList?.map(
                            (overtimeList, index) => (
                              <>
                                {overtimeList?.shiftWeeklyOvertimeList?.some(item => item?.remainingMinutes < 0) && <p className='fw-bold'>
                                  {overtimeList?.locationName}
                                </p>}
                                {
                                  overtimeList?.shiftWeeklyOvertimeList?.map((shiftWeek, index) => (
                                    <React.Fragment key={index}>
                                      {shiftWeek?.remainingMinutes < 0 && (
                                        <div >

                                          {/* {`${overtimeValidModal.response?.candidateName} `}
                                          has used
                                          {shiftWeek?.candidateOverLimtHours
                                            ? ` ${shiftWeek?.candidateOverLimtHours}hrs `
                                            : " 40hrs "}
                                          of allowed shift time from {shiftWeek?.weekStartDate} to {shiftWeek?.weekEndDate}. */}
                                         {`${overtimeValidModal.response?.candidateName} (Allowed straight time work hours: ${shiftWeek?.candidateOverLimtHours}) `}
                                            has used{" "}
                                            {getHoursandMinutes(shiftWeek?.workedStrightHours) ?? ""}
                                            {" "}
                                             of straight time and{" "}
                                            {
                                             getHoursandMinutes( shiftWeek?.workedShiftOverTimeHours) ?? ""
                                            }
                                            {" "}
                                             of overtime from{" "}
                                            {shiftWeek?.weekStartDate} to{" "}
                                            {shiftWeek?.weekEndDate}. This shift
                                            will put{" "}
                                            {getHoursandMinutes(shiftWeek?.currentStrightHours) ?? ""}{" "}
                                             of straight time and{" "}
                                            {
                                              getHoursandMinutes(shiftWeek?.currentShiftOverTimeHours) ?? ""
                                            }{" "}
                                             of overtime.
                                        </div>
                                      )}
                                    </React.Fragment>
                                  ))
                                }
                              </>

                            )
                          )}
                          <span>Do you want to override the overtime limitation ?</span>
                        </div>
                      </Modal>
                    )}
                    {showStatusWaring && (
                      <Modal
                        showHide={hideStatusWaringModal}
                        label={'Alert'}
                        size={'md'}
                        center={true}
                        saveFunction={changeStatus}
                      >
                        <span className="fw-bold">
                          You are skipping an approval step and do you want to
                          continue?
                        </span>
                      </Modal>
                    )}
                    {showShiftRelase && (
                      <Modal
                        showHide={closeShiftRelease}
                        label={'Shift Release Order'}
                        buttonName={'Post Job'}
                        saveFunction={shiftOrderSaveAndValidate}
                      >
                        <Shiftorder
                          shiftReleaseOderList={shiftReleaseOderList}
                          shiftReleaseOderWaitTimeList={
                            shiftReleaseOderWaitTimeList
                          }
                          getShiftoderData={getShiftoderData}
                          errors={shiftOderValidation}
                          draggedData={shiftOrderSelectedData['data']}
                          formData={shiftOrderSelectedData['form']}
                          closeShiftRelease={closeShiftRelease}
                          setNoOfShiftNeeded={setNoOfShiftNeeded}
                          NoOfShiftsneeded={NoOfShiftsneeded}
                        />
                      </Modal>
                    )}
                    {showRepostModal && (
                      <Modal
                        showHide={hidePostModal}
                        label={'Alert'}
                        size={'md'}
                        center={true}
                        saveFunction={savePostAgain}
                      >
                        <span className="fw-bold">
                          The shift is already posted, do you want to re-post
                          it?
                        </span>
                      </Modal>
                    )}
                    <div className="card-header">
                      <h3 className="card-title">Shift Information</h3>
                      {/* ${((+hideEditJobShiftType === shiftTypeObj.repost) || (+hideEditJobShiftType === shiftTypeObj.multiShift)) ? 'is-disabled-edit' : ''} */}
                      <div className="card-options">
                      {((+hideEditJobShiftType === shiftTypeObj.repost) ||
                        (+hideEditJobShiftType ===
                          shiftTypeObj.multiShift)) ? null : (
                          <a
                            // +hideEditJobShiftType === shiftTypeObj.repost
                            href="#"
                            className={`btn btn-light float-left `}
                            onClick={editJob}
                          >
                            Edit Shift
                          </a>
                        )}

                        <a
                          href="javascript:void(0)"
                          className="card-options-collapse"
                          data-bs-toggle="card-collapse"
                        >
                          <i className="fe fe-chevron-up"></i>
                        </a>
                      </div>
                    </div>





                    {/* Shift Information Details With Search Filter Section  */}
                    <div className="card-body d-flex flex-column gap-3">
                        {/* First Row */}
                        <div className='row d-flex justify-content-between'>
                        {/* Location Name */}
                        <div className='col-2 d-flex flex-column'>
                        <label className="form-label">Location Name:</label>
                        <span>{jobInfo?.locationName}</span>
                        </div>
                        {/* Shift Position Title */}
                        <div className='col-2 d-flex flex-column'>
                        <label className="form-label">Shift Position Title:</label>
                        <span>{jobInfo?.jobTitle}</span>
                        </div>
                        {/* Department */}
                        <div className='col-2 d-flex flex-column'>
                        <label className="form-label">Department:</label>
                        <span>{jobInfo?.departmentName}</span>
                        </div>
                        {/* Recurrecne */}
                        <div className='col-2 d-flex flex-column'>
                        <label className="form-label">Recurrecne:</label>
                        <span>{jobInfo?.shiftTypeToDisplay}</span>
                        </div>
                        {/* Payrate */}
                        <div className='col-2 d-flex flex-column'>
                        <label className="form-label">Payrate:</label>
                        <span>{jobInfo?.payRateTypeToDisplay}</span>
                        </div>
                        </div>
                        {/* Second Row */}
                        <div className='row d-flex justify-content-between'>
                        {/* Shift Start Date*/}
                        <div className='col-2 d-flex flex-column'>
                        {parseInt(jobInfo?.shiftType) === 3 ? 
                        <label className="form-label">Multishift Start Date:</label> :
                        <label className="form-label">Shift Start Date:</label>
                        }
                        <span>{jobInfo?.shiftStartDateToDisplay}  {jobInfo?.shiftStartTimeToDisplay}</span>
                        </div>
                        {/* Shift End Date */}
                        <div className='col-2 d-flex flex-column'>
                        { parseInt(jobInfo?.shiftType) === 3 ?
                        <label className="form-label">Multishift End Date:</label> :
                        <label className="form-label">Shift End Date:</label>
                        }
                        <span>{jobInfo?.shiftEndDateToDisplay}  {jobInfo?.shiftEndTimeToDisplay}</span>
                        </div>
                        {/* Shift Length */}
                        <div className='col-2 d-flex flex-column'>
                        <label className="form-label">Shift Length:</label>
                        <span>{jobInfo?.shiftHours ? shiftHoursCalc(jobInfo?.shiftHours) : ''}</span>
                        </div>
                        {/* {jobInfo?.shiftType === 3 ?
                          <>
                        <div className='col-2 d-flex flex-column'>
                        <label className="form-label">Multishift Start Date:</label>
                        <span>{jobInfo?.multishiftStartDate}</span>
                        </div>
                        <div className='col-2 d-flex flex-column'>
                        <label className="form-label">Multishift End Date:</label>
                        <span>{jobInfo?.multishiftEndDate}</span>
                        </div> 
                        </> :  */}
                        <>
                        <div className='col-2'></div>
                        <div className='col-2'></div>
                        </>
                        {/* } */}
                        </div>
                        {/* 3rd Row */}
                        <div className='row d-flex justify-content-between'>
                        {/* Select Team */}
                        <div className='col-5'>
                        {jobInfo?.shiftType !== 2 &&
                            <div className="form-group">
                              <label htmlFor={'Select Team'} className="form-label">
                                Select Team:
                              </label>
                              <select
                                disabled={jobInfo?.isMultiShiftMultiLocation}
                                className="form-select"
                                data-placeholder="Select Team"
                                value={params.candidateTeamId}
                                name={'candidateTeamId'}
                                onChange={(event) => teamsUpdateVal(event.target)}
                              >
                                <option value={'0'}>-- Select --</option>
                                {
                                  teamNameList.map && teamNameList.map(
                                    (option) => (
                                      <option value={option.id}>
                                        {option.name}
                                      </option>
                                    )
                                  )
                                }
                              </select>
                            </div>
                      }
                        </div>
                        {/* Enter Distance Radius Miles */}
                        <div className='col-4'>
                        <div className="form-group">
                            <label htmlFor={'distance'} className="form-label">
                              Enter Distance Radius Miles:
                            </label>

                            <select
                              className="form-select"
                              value={params.distance}
                              name="distance"
                              onChange={(e) => {
                                updateDropVal(e.target);
                              }}
                            >
                              <option value="">Select</option>
                              {masterData.travelDistanceList.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                            {searchErrors['distance'] &&
                              searchErrors['distance'].map((error) => (
                                <div className="invalid-input">{error}</div>
                              ))}
                        </div>
                        </div>
                        {/* Filter Buttons */}
                        <div className='col-3 d-flex justify-content-end'>
                        <div className="form-group">
                        <label></label>
                        <div className='d-flex gap-2 mt-3'>
                        <button
                          className="btn btn-primary sw-btn-next"
                          type="button"
                          onClick={filterTable}
                        >
                           Filter
                        </button>    
                        <button
                          className="btn btn-danger"
                          onClick={clearFilter}
                        >
                          Clear
                        </button>
                        </div>
                        </div>
                        </div>
                        </div>

                      






                    </div>















                    {/* <div className="card-body"> */}
                      {/* <div className="row">
                        <DropDown
                          name={'searchStatus'}
                          label={'Status'}
                          placeholder={'Select Location Name'}
                          updateValue={updateStstusDropVal}
                          value={params.searchStatus}
                          options={masterData.statusList}
                          showArrow={true}
                          isObject={true}
                          multiple={true}
                          errors={''}
                          divClass={'col-lg-4 col-md-4'}
                        />
                        <div className="col-lg-4 col-md-4">
                          <div className="form-group">
                            <label htmlFor={'distance'}>
                              Enter Distance Radius Miles
                            </label>

                            <select
                              className="form-select"
                              value={params.distance}
                              name="distance"
                              onChange={(e) => {
                                updateDropVal(e.target);
                              }}
                            >
                              <option value="">Select</option>
                              {masterData.travelDistanceList.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                            {searchErrors['distance'] &&
                              searchErrors['distance'].map((error) => (
                                <div className="invalid-input">{error}</div>
                              ))}
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <div className="form-group">
                            <label htmlFor={'matchingCriteria'}>
                              Matching Criteria
                            </label>
                            <select
                              className="form-select"
                              data-placeholder="Matching Criteria"
                              value={params.matchingCriteria}
                              name={'matchingCriteria'}
                              onChange={(event) => updateDropVal(event.target)}
                            >
                              <option value={''}>Select all</option>
                              {
                                masterData.matchingCriteriaList.map(
                                  (option) => (
                                    <option value={option.id}>
                                      {option.name}
                                    </option>
                                  )
                                )
                              }
                            </select>
                          </div>
                        </div>
                      </div> */}

                      {/* {jobInfo?.shiftType !== 2 &&
                        <div className='row'>
                          <div className="col-lg-4 col-md-4">
                            <div className="form-group">
                              <label htmlFor={'Select Team'}>
                                Select Team
                              </label>
                              <select
                                disabled={jobInfo?.isMultiShiftMultiLocation}
                                className="form-select"
                                data-placeholder="Select Team"
                                value={params.candidateTeamId}
                                name={'candidateTeamId'}
                                onChange={(event) => teamsUpdateVal(event.target)}
                              >
                                <option value={'0'}>-- Select --</option>
                                {
                                  teamNameList.map && teamNameList.map(
                                    (option) => (
                                      <option value={option.id}>
                                        {option.name}
                                      </option>
                                    )
                                  )
                                }
                              </select>
                            </div>
                          </div>
                        </div>
                      } */}
                      {/* <div className="row">
                        <div className="col-lg-6 col-md-3"></div>
                        <div className="col-lg-6 col-md-3">
                          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
                            <div
                              className="btn-group me-2 sw-btn-group"
                              role="group"
                            >
                              <button
                                className="btn btn-primary sw-btn-next"
                                type="button"
                                onClick={filterTable}
                              >
                                Filter
                              </button>
                            </div>
                            <div
                              className="btn-group mr-2 sw-btn-group-extra"
                              role="group"
                            >
                              <button
                                className="btn btn-danger"
                                onClick={clearFilter}
                              >
                                Clear
                              </button>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    {/* </div> */}
                  </div>

                  <GridTable
                    columns={newColumn}
                    data={tableData}
                    dontShowColumns={dontShowColumnsList}
                    skipPageReset={skipPageReset}
                    updateData={changeheStatus}
                    hideColumns={hideSecurityJobColumns}
                    title={'Matching Candidate'}
                    postJob={postJob}
                    favorite={true}
                    favoriteandUnfavorite={favoriteandUnfavorite}
                    addMentor_RemoveMentor={addMentor_RemoveMentor}
                    bestmatch={true}
                    bestmatchfun={bestmatch}
                    openShiftRelease={openShiftRelease}
                    postjobDisable={postjobDisable}
                    IsBestMatch={params.IsBestMatch}
                    selectCandidate={selectCandidate}
                    getSelectCandidate={getSelectCandidate}
                    setSelectCandidate={setSelectCandidate}
                    openShiftAssignJobToCandidateRelese={
                      openShiftAssignJobToCandidateRelese
                    }
                    openShiftAssignJobToCandidateMultipleRelese={openShiftAssignJobToCandidateMultipleRelese}
                    shiftType={jobInfo?.shiftType}
                    groupEmailModalPopup={groupEmailModalPopup}
                    groupSMSModalPopup={groupSMSModalPopup}
                    params={params}
                    teamAssignEnableBtn={teamAssignEnableBtn}
                    handlePageChange={handlePageChange}
                    currentPage={params.page}
                    pageSize={params.pageSize}
                    totalCount={totalCount}
                    handlePageSize={handlePageSize}
                    pageName={"Matching_candidate"}
                    isDataNotFound={isDataNotFound}
                    jobInfo={jobInfo}
                    onSort = {handleSort}
                    sortOrderType ={sortOrderType}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
